var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerimg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2173.91 1392.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#bdd0fb;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-11,.cls-17,.cls-170,.cls-171,.cls-22,.cls-32,.cls-35,.cls-53,.cls-7{fill:#fff;}.cls-7{opacity:0.45;}.cls-8{fill:#2b69b3;}.cls-9{fill:#91b3fa;}.cls-10{fill:#18174a;}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17,.cls-37{opacity:0.6;}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{opacity:0.72;}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{opacity:0.79;}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{opacity:0.78;}.cls-36{fill:url(#linear-gradient-26);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{fill:url(#linear-gradient-28);}.cls-40{fill:url(#linear-gradient-29);}.cls-41{fill:url(#linear-gradient-30);}.cls-42{fill:url(#linear-gradient-31);}.cls-43{fill:url(#linear-gradient-32);}.cls-44{fill:url(#linear-gradient-33);}.cls-45{fill:url(#linear-gradient-34);}.cls-46{fill:url(#linear-gradient-35);}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{opacity:0.62;}.cls-54{fill:url(#linear-gradient-42);}.cls-55{fill:url(#linear-gradient-43);}.cls-56{fill:url(#linear-gradient-44);}.cls-57{fill:url(#linear-gradient-45);}.cls-58{fill:url(#linear-gradient-46);}.cls-59{fill:url(#linear-gradient-47);}.cls-60{fill:url(#linear-gradient-48);}.cls-61{fill:url(#linear-gradient-49);}.cls-62{fill:url(#linear-gradient-50);}.cls-63{fill:url(#linear-gradient-51);}.cls-64{fill:url(#linear-gradient-52);}.cls-65{fill:url(#linear-gradient-53);}.cls-66{fill:url(#linear-gradient-54);}.cls-67{fill:url(#linear-gradient-55);}.cls-68{fill:url(#linear-gradient-56);}.cls-69{fill:url(#linear-gradient-57);}.cls-70{fill:url(#linear-gradient-58);}.cls-71{fill:url(#linear-gradient-59);}.cls-72{fill:url(#linear-gradient-60);}.cls-73{fill:url(#linear-gradient-61);}.cls-74{fill:url(#linear-gradient-62);}.cls-75{fill:url(#linear-gradient-63);}.cls-76{fill:url(#linear-gradient-64);}.cls-77{fill:url(#linear-gradient-65);}.cls-78{fill:url(#linear-gradient-66);}.cls-79{fill:url(#linear-gradient-67);}.cls-80{fill:url(#linear-gradient-68);}.cls-81{fill:url(#linear-gradient-69);}.cls-82{fill:url(#linear-gradient-70);}.cls-83{fill:url(#linear-gradient-71);}.cls-84{fill:url(#linear-gradient-72);}.cls-85{fill:url(#linear-gradient-73);}.cls-86{fill:url(#linear-gradient-74);}.cls-87{fill:url(#linear-gradient-75);}.cls-88{fill:url(#linear-gradient-76);}.cls-89{fill:url(#linear-gradient-77);}.cls-90{fill:url(#linear-gradient-78);}.cls-91{fill:url(#linear-gradient-79);}.cls-92{fill:url(#linear-gradient-80);}.cls-93{fill:url(#linear-gradient-81);}.cls-94{fill:url(#linear-gradient-82);}.cls-95{fill:url(#linear-gradient-83);}.cls-96{fill:url(#linear-gradient-84);}.cls-97{fill:url(#linear-gradient-85);}.cls-98{fill:url(#linear-gradient-86);}.cls-99{fill:url(#linear-gradient-87);}.cls-100{fill:url(#linear-gradient-88);}.cls-101{fill:url(#linear-gradient-89);}.cls-102{fill:url(#linear-gradient-90);}.cls-103{fill:url(#linear-gradient-91);}.cls-104{fill:url(#linear-gradient-92);}.cls-105{fill:url(#linear-gradient-93);}.cls-106{fill:url(#linear-gradient-94);}.cls-107{fill:url(#linear-gradient-95);}.cls-108{fill:url(#linear-gradient-96);}.cls-109{fill:url(#linear-gradient-97);}.cls-110{fill:url(#linear-gradient-98);}.cls-111{fill:url(#linear-gradient-99);}.cls-112{fill:url(#linear-gradient-100);}.cls-113{fill:url(#linear-gradient-101);}.cls-114{fill:url(#linear-gradient-102);}.cls-115{fill:url(#linear-gradient-103);}.cls-116{fill:url(#linear-gradient-104);}.cls-117{fill:url(#linear-gradient-105);}.cls-118{fill:url(#linear-gradient-106);}.cls-119{fill:url(#linear-gradient-107);}.cls-120{fill:url(#linear-gradient-108);}.cls-121{fill:url(#linear-gradient-109);}.cls-122{fill:url(#linear-gradient-110);}.cls-123{fill:url(#linear-gradient-111);}.cls-124{fill:url(#linear-gradient-112);}.cls-125{fill:url(#linear-gradient-113);}.cls-126{fill:url(#linear-gradient-114);}.cls-127{fill:url(#linear-gradient-115);}.cls-128{fill:url(#linear-gradient-116);}.cls-129{fill:url(#linear-gradient-117);}.cls-130{fill:url(#linear-gradient-118);}.cls-131{fill:url(#linear-gradient-119);}.cls-132{fill:url(#linear-gradient-120);}.cls-133{fill:url(#linear-gradient-121);}.cls-134{fill:url(#linear-gradient-122);}.cls-135{fill:url(#linear-gradient-123);}.cls-136{fill:url(#linear-gradient-124);}.cls-137{fill:url(#linear-gradient-125);}.cls-138{fill:url(#linear-gradient-126);}.cls-139{fill:url(#linear-gradient-127);}.cls-140{fill:url(#linear-gradient-128);}.cls-141{fill:url(#linear-gradient-129);}.cls-142{fill:url(#linear-gradient-130);}.cls-143{fill:url(#linear-gradient-131);}.cls-144{fill:url(#linear-gradient-132);}.cls-145{fill:url(#linear-gradient-133);}.cls-146{fill:url(#linear-gradient-134);}.cls-147{fill:url(#linear-gradient-135);}.cls-148{fill:url(#linear-gradient-136);}.cls-149{fill:url(#linear-gradient-137);}.cls-150{fill:url(#linear-gradient-138);}.cls-151{fill:url(#linear-gradient-139);}.cls-152{fill:url(#linear-gradient-140);}.cls-153{fill:#7d97f4;}.cls-154{fill:url(#linear-gradient-141);}.cls-155{fill:url(#linear-gradient-142);}.cls-156{fill:url(#linear-gradient-143);}.cls-157{fill:url(#linear-gradient-144);}.cls-158{fill:url(#linear-gradient-145);}.cls-159{fill:url(#linear-gradient-146);}.cls-160{fill:url(#linear-gradient-147);}.cls-161{fill:url(#linear-gradient-148);}.cls-162{fill:url(#linear-gradient-149);}.cls-163{fill:url(#linear-gradient-150);}.cls-164{fill:url(#linear-gradient-151);}.cls-165{fill:url(#linear-gradient-152);}.cls-166{fill:url(#linear-gradient-153);}.cls-167{fill:url(#linear-gradient-154);}.cls-168{fill:url(#linear-gradient-155);}.cls-169{fill:url(#linear-gradient-156);}.cls-170{opacity:0.68;}.cls-171{opacity:0.5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 707.17,
    x2: 2173.91,
    y2: 707.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 707.17,
    x2: 2173.91,
    y2: 707.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1295.22,
    y1: 632.06,
    x2: 1833.43,
    y2: 632.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 361.26,
    y1: 773.74,
    x2: 675.34,
    y2: 773.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 195.49,
    y1: 1010.3,
    x2: 715.15,
    y2: 1010.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1692.51,
    y1: 337.76,
    x2: 2029.98,
    y2: 337.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1709.87,
    y1: 321.93,
    x2: 1714.06,
    y2: 321.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1725.73,
    y1: 238.73,
    x2: 1889.41,
    y2: 238.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1726.73,
    y1: 340.98,
    x2: 2002.86,
    y2: 340.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1850.25,
    y1: 436.08,
    x2: 1896.92,
    y2: 160.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1549.17,
    y1: 1106.63,
    x2: 1498.6,
    y2: 1204.72,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 17.78, -544.8)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1595.26,
    y1: 1104.17,
    x2: 1544.69,
    y2: 1202.26,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 17.78, -544.8)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1656.71,
    y1: 1104.17,
    x2: 1606.15,
    y2: 1202.26,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 17.78, -544.8)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1718.16,
    y1: 1100.84,
    x2: 1667.6,
    y2: 1198.94,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 17.78, -544.8)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 313.29,
    y1: 97.77,
    x2: 345.53,
    y2: 97.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 296.51,
    y1: 97.57,
    x2: 362.72,
    y2: 97.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 235.63,
    y1: 241.4,
    x2: 262.08,
    y2: 241.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 221.87,
    y1: 241.24,
    x2: 276.18,
    y2: 241.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 474.03,
    y1: 63.5,
    x2: 500.48,
    y2: 63.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 460.26,
    y1: 63.34,
    x2: 514.58,
    y2: 63.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 680.19,
    y1: -119.22,
    x2: 630.69,
    y2: -3.73,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 347.95,
    y1: 300.59,
    x2: 352.05,
    y2: 300.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 363.16,
    y1: 212.66,
    x2: 520.15,
    y2: 212.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 684.61,
    y1: 321.77,
    x2: 509.12,
    y2: 555.76,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 187.35,
    y1: 774.51,
    x2: 191.45,
    y2: 774.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 394.29,
    y1: 629.07,
    x2: 459.29,
    y2: 473.07,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -76.24,
    y1: 1506.82,
    x2: -53.74,
    y2: 1410.32,
    gradientTransform: "translate(-349.5 -1417.03) rotate(-21.97)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -66.78,
    y1: 1509.02,
    x2: -44.28,
    y2: 1412.52,
    gradientTransform: "translate(-349.5 -1417.03) rotate(-21.97)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -59.46,
    y1: 1510.73,
    x2: -36.96,
    y2: 1414.23,
    gradientTransform: "translate(-349.5 -1417.03) rotate(-21.97)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -52.24,
    y1: 1512.41,
    x2: -29.74,
    y2: 1415.91,
    gradientTransform: "translate(-349.5 -1417.03) rotate(-21.97)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 56.35,
    y1: 1488.58,
    x2: 38.35,
    y2: 1538.58,
    gradientTransform: "matrix(0.94, -0.34, 0.34, 0.94, -297.85, -1304.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 278.6,
    y1: 529.74,
    x2: 278.6,
    y2: 568.74,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 677.7,
    y1: 626.99,
    x2: 574.21,
    y2: 889.47,
    gradientTransform: "translate(139.24 -42.69) rotate(6.47)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 298.22,
    y1: 1211.96,
    x2: 300.65,
    y2: 1211.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 307.91,
    y1: 1120.67,
    x2: 460.11,
    y2: 1120.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 459.33,
    y1: 1190.97,
    x2: 367.33,
    y2: 1434.97,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 550.95,
    y1: 252.06,
    x2: 549.39,
    y2: 214.12,
    gradientTransform: "translate(-63.63 760.58) rotate(13.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 548.97,
    y1: 195.09,
    x2: 556.79,
    y2: 303.84,
    gradientTransform: "translate(-63.63 760.58) rotate(13.46)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 656.67,
    y1: 247.7,
    x2: 655.1,
    y2: 209.76,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 654.4,
    y1: 187.51,
    x2: 662.22,
    y2: 296.25,
    gradientTransform: "translate(-63.63 760.58) rotate(13.46)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 575.1,
    y1: 876.38,
    x2: 551.1,
    y2: 928.88,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 545.89,
    y1: 1062.13,
    x2: 389.89,
    y2: 1262.13,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 616.97,
    y1: 239.48,
    x2: 601.72,
    y2: 360.35,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 459.33,
    y1: 1198.61,
    x2: 424.83,
    y2: 1278.61,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 861.03,
    y1: 714.75,
    x2: 874.07,
    y2: 714.75,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 838.2,
    y1: 706.08,
    x2: 852.19,
    y2: 706.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 814.57,
    y1: 700.29,
    x2: 829.29,
    y2: 700.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 790.52,
    y1: 697.36,
    x2: 805.77,
    y2: 697.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 766.39,
    y1: 697.25,
    x2: 781.93,
    y2: 697.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 742.46,
    y1: 699.74,
    x2: 758.15,
    y2: 699.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 719.02,
    y1: 704.81,
    x2: 734.71,
    y2: 704.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 696.33,
    y1: 712.39,
    x2: 711.89,
    y2: 712.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 674.68,
    y1: 722.42,
    x2: 689.97,
    y2: 722.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 654.38,
    y1: 734.83,
    x2: 669.23,
    y2: 734.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 635.75,
    y1: 749.55,
    x2: 649.97,
    y2: 749.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 618.96,
    y1: 766.33,
    x2: 632.54,
    y2: 766.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 604.18,
    y1: 784.89,
    x2: 617,
    y2: 784.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 591.47,
    y1: 804.96,
    x2: 603.44,
    y2: 804.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 580.89,
    y1: 826.26,
    x2: 591.97,
    y2: 826.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 572.46,
    y1: 848.55,
    x2: 582.65,
    y2: 848.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 566.22,
    y1: 871.58,
    x2: 575.5,
    y2: 871.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 562.21,
    y1: 895.15,
    x2: 570.56,
    y2: 895.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 560.49,
    y1: 919.03,
    x2: 567.87,
    y2: 919.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 560.5,
    y1: 943.02,
    x2: 568.15,
    y2: 943.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 562.3,
    y1: 966.87,
    x2: 571.3,
    y2: 966.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 566.46,
    y1: 990.38,
    x2: 576.74,
    y2: 990.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 572.83,
    y1: 1013.32,
    x2: 584.34,
    y2: 1013.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 581.29,
    y1: 1035.55,
    x2: 593.94,
    y2: 1035.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 591.7,
    y1: 1056.89,
    x2: 605.43,
    y2: 1056.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 603.91,
    y1: 1077.23,
    x2: 618.65,
    y2: 1077.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 617.8,
    y1: 1096.45,
    x2: 633.48,
    y2: 1096.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 633.26,
    y1: 1114.42,
    x2: 649.77,
    y2: 1114.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 650.16,
    y1: 1131.06,
    x2: 667.44,
    y2: 1131.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 668.38,
    y1: 1146.24,
    x2: 686.38,
    y2: 1146.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 687.84,
    y1: 1159.84,
    x2: 706.45,
    y2: 1159.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 708.33,
    y1: 1171.79,
    x2: 727.56,
    y2: 1171.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 729.76,
    y1: 1182.08,
    x2: 749.47,
    y2: 1182.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 751.94,
    y1: 1190.7,
    x2: 772.06,
    y2: 1190.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 774.73,
    y1: 1197.66,
    x2: 795.19,
    y2: 1197.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 797.99,
    y1: 1202.97,
    x2: 818.73,
    y2: 1202.97,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 821.6,
    y1: 1206.64,
    x2: 842.51,
    y2: 1206.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 845.46,
    y1: 1208.71,
    x2: 866.47,
    y2: 1208.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 869.43,
    y1: 1209.16,
    x2: 890.48,
    y2: 1209.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 893.4,
    y1: 1208.04,
    x2: 914.44,
    y2: 1208.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 917.28,
    y1: 1205.34,
    x2: 938.21,
    y2: 1205.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 940.95,
    y1: 1201.1,
    x2: 961.81,
    y2: 1201.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 964.34,
    y1: 1195.44,
    x2: 985.06,
    y2: 1195.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 987.38,
    y1: 1188.45,
    x2: 1007.92,
    y2: 1188.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1010.02,
    y1: 1180.23,
    x2: 1030.36,
    y2: 1180.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1032.22,
    y1: 1170.88,
    x2: 1052.36,
    y2: 1170.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1053.96,
    y1: 1160.52,
    x2: 1073.88,
    y2: 1160.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1075.27,
    y1: 1149.24,
    x2: 1094.92,
    y2: 1149.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1096.13,
    y1: 1137.14,
    x2: 1115.51,
    y2: 1137.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1116.54,
    y1: 1124.31,
    x2: 1135.66,
    y2: 1124.31,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1136.51,
    y1: 1110.83,
    x2: 1155.39,
    y2: 1110.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1156.09,
    y1: 1096.78,
    x2: 1174.73,
    y2: 1096.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1175.29,
    y1: 1082.24,
    x2: 1193.71,
    y2: 1082.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1194.14,
    y1: 1067.25,
    x2: 1212.35,
    y2: 1067.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1212.67,
    y1: 1051.89,
    x2: 1230.69,
    y2: 1051.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1230.93,
    y1: 1036.23,
    x2: 1248.77,
    y2: 1036.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1249,
    y1: 1020.33,
    x2: 1266.64,
    y2: 1020.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1266.92,
    y1: 1004.26,
    x2: 1284.39,
    y2: 1004.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1284.73,
    y1: 988.09,
    x2: 1302.05,
    y2: 988.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1302.49,
    y1: 971.88,
    x2: 1319.69,
    y2: 971.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1320.24,
    y1: 955.69,
    x2: 1337.36,
    y2: 955.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1338.05,
    y1: 939.57,
    x2: 1355.12,
    y2: 939.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1355.97,
    y1: 923.6,
    x2: 1373,
    y2: 923.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1374.08,
    y1: 907.83,
    x2: 1391.05,
    y2: 907.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1392.42,
    y1: 892.32,
    x2: 1409.34,
    y2: 892.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1411.02,
    y1: 877.14,
    x2: 1427.91,
    y2: 877.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1429.93,
    y1: 862.37,
    x2: 1446.82,
    y2: 862.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1449.2,
    y1: 848.06,
    x2: 1466.1,
    y2: 848.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1468.86,
    y1: 834.32,
    x2: 1485.76,
    y2: 834.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1488.94,
    y1: 821.28,
    x2: 1505.95,
    y2: 821.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1509.63,
    y1: 809.21,
    x2: 1526.73,
    y2: 809.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1530.98,
    y1: 798.37,
    x2: 1548.2,
    y2: 798.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1553.04,
    y1: 789.09,
    x2: 1570.39,
    y2: 789.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1575.82,
    y1: 781.77,
    x2: 1593.3,
    y2: 781.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1599.27,
    y1: 776.86,
    x2: 1616.76,
    y2: 776.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1623.25,
    y1: 774.77,
    x2: 1640.54,
    y2: 774.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1647.5,
    y1: 775.89,
    x2: 1664.17,
    y2: 775.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1671.27,
    y1: 781.07,
    x2: 1687.16,
    y2: 781.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1694.01,
    y1: 790.07,
    x2: 1708.81,
    y2: 790.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1715.13,
    y1: 802.58,
    x2: 1728.55,
    y2: 802.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1734,
    y1: 818.4,
    x2: 1745.65,
    y2: 818.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 1749.77,
    y1: 837.33,
    x2: 1759.11,
    y2: 837.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1761.41,
    y1: 858.98,
    x2: 1767.73,
    y2: 858.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1767.64,
    y1: 882.28,
    x2: 1770.45,
    y2: 882.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 9438.3,
    y1: 1260.07,
    x2: 9455.14,
    y2: 1260.07,
    gradientTransform: "matrix(-1, 0.01, 0.01, 1, 10994.39, -56.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 9377.61,
    y1: 1259.21,
    x2: 9392.15,
    y2: 1259.21,
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1604.81,
    y1: 912.68,
    x2: 1470.15,
    y2: 1071.34,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 9507.62,
    y1: 820.73,
    x2: 9593.65,
    y2: 820.73,
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1439.61,
    y1: 723.42,
    x2: 1418.95,
    y2: 758.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1430.16,
    y1: 739.77,
    x2: 1384.82,
    y2: 836.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1637.28,
    y1: 940.23,
    x2: 1502.61,
    y2: 1098.9,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1672.47,
    y1: 843.43,
    x2: 1659.8,
    y2: 881.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1570.52,
    y1: 815.48,
    x2: 1585.85,
    y2: 909.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 2389.05,
    y1: 1428.06,
    x2: 2357.72,
    y2: 1502.73,
    gradientTransform: "matrix(-0.75, -0.66, -0.66, 0.75, 5283.15, -1617.87)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 2373.09,
    y1: 1421.36,
    x2: 2341.76,
    y2: 1496.03,
    gradientTransform: "matrix(-0.75, -0.66, -0.66, 0.75, 5283.15, -1617.87)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1620.44,
    y1: 863.96,
    x2: 1602.44,
    y2: 902.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1405.86,
    y1: 1300.99,
    x2: 1423.81,
    y2: 1300.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1490.9,
    y1: 1302.5,
    x2: 1512.33,
    y2: 1302.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1404.89,
    y1: 942.78,
    x2: 1339.56,
    y2: 1045.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1328.12,
    y1: 1061.01,
    x2: 1444.51,
    y2: 1252.09,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1409.15,
    y1: 983.41,
    x2: 1356.48,
    y2: 1086.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 1462.12,
    y1: 1104.08,
    x2: 1511.63,
    y2: 1104.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 2633.45,
    y1: 160.11,
    x2: 2670.78,
    y2: 242.77,
    gradientTransform: "translate(-2055.03 -173.18) rotate(-7.5)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 2616.5,
    y1: 167.76,
    x2: 2653.83,
    y2: 250.42,
    gradientTransform: "translate(-2055.03 -173.18) rotate(-7.5)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1721.4,
    y1: 1226.59,
    x2: 1795.58,
    y2: 1226.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1717.04,
    y1: 990.59,
    x2: 1715.7,
    y2: 1068.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1808.12,
    y1: 1004.77,
    x2: 1891.31,
    y2: 1185.82,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 1811.69,
    y1: 1026.8,
    x2: 1801.12,
    y2: 958.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -148.67,
    y1: 556.66,
    x2: -160,
    y2: 634.66,
    gradientTransform: "translate(-1866.85 -2851.91) rotate(-52.83)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -132.86,
    y1: 564,
    x2: -144.19,
    y2: 642,
    gradientTransform: "translate(-1866.85 -2851.91) rotate(-52.83)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1861.23,
    y1: 965.83,
    x2: 1849.89,
    y2: 1032.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1174.79,
    y1: 1086.94,
    x2: 1099.79,
    y2: 582.89,
    xlinkHref: "#linear-gradient-10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.57,119.91c-168.62,139.36,56.79,318.25-60,396.34S-273.83,746.64,213.2,1048.79s511.68,448.87,859.36,257.55,311.45-172.21,597.57-42.87,585.16-71.89,483.49-310.7-166.42-235.83-50.31-388.34-86-655.49-485.71-329.34-443.17,133.63-612.17-36C913.93,107.3,653.05-100.33,386.57,119.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.57,119.91c-168.62,139.36,56.79,318.25-60,396.34S-273.83,746.64,213.2,1048.79s511.68,448.87,859.36,257.55,311.45-172.21,597.57-42.87,585.16-71.89,483.49-310.7-166.42-235.83-50.31-388.34-86-655.49-485.71-329.34-443.17,133.63-612.17-36C913.93,107.3,653.05-100.33,386.57,119.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1905.21,194.13a9.74,9.74,0,0,0-13.27-10.46c-106.85,42.84-718.49,317.59-563.76,937.85C1328.18,1121.52,1777.4,1044.3,1905.21,194.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1833.18,284c-26,26-51.4,52.55-76.59,79.31s-50.06,53.83-74.61,81.17-48.79,55-72.69,82.9-47.34,56.22-70.43,84.81c-46.08,57.24-90.51,115.85-131.63,176.73q-31,45.57-58.52,93.3c-18.27,31.82-35.3,64.39-49.64,98.13h0a2,2,0,0,1-3.68-1.56h0c14.53-33.91,31.71-66.56,50.12-98.43s38.13-63,58.9-93.36c41.34-60.88,86-119.43,132.24-176.6q34.78-42.82,70.71-84.68T1680.29,443q37-40.93,74.86-81c25.27-26.71,50.78-53.19,76.83-79.15a.85.85,0,0,1,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.42,259.66c-19.66,113.43-107.11,778.21,502,972.32,0,0,170.23-422.83-486.1-978.12A9.74,9.74,0,0,0,308.42,259.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.93,362.36c8.5,35.75,17.73,71.33,27.26,106.83s19.52,70.87,29.9,106.12,21.16,70.4,32.36,105.4,23,69.81,35.17,104.48c24.51,69.27,51,137.87,81.27,204.83q22.49,50.3,48.65,98.8c17.48,32.26,36.25,63.86,57.43,93.79h0a2,2,0,1,1-3.27,2.31h0c-21.23-30.16-40-61.93-57.44-94.34s-33.57-65.53-48.51-99.15c-30.09-67.16-56.47-135.9-80.82-205.3Q466.76,734.05,450,681.49T417.91,576q-15.44-53-29.63-106.25c-9.45-35.54-18.59-71.15-27-107a.86.86,0,0,1,.64-1,.85.85,0,0,1,1,.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.56,770.28a6,6,0,0,1,9.37-6.79C194.69,802.22,317.86,900,422.63,925.23c170.6,41.06,353.74,171.27,352.1,304C774.73,1229.25,391.81,1397,139.56,770.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.44,831.25c1,1.18,2.18,2.4,3.3,3.6l3.44,3.57,7,7.06c4.68,4.69,9.4,9.32,14.13,13.95q14.25,13.82,28.81,27.32,29.07,27.06,59.17,53c40.16,34.47,81.48,67.63,124.37,98.63,5.31,3.94,10.78,7.68,16.16,11.51l8.1,5.74c2.7,1.91,5.46,3.74,8.18,5.62,5.47,3.71,10.9,7.49,16.4,11.16l16.59,10.89,4.16,2.71,4.2,2.64,8.4,5.27,8.4,5.27c2.81,1.74,5.67,3.41,8.5,5.12,5.69,3.37,11.33,6.83,17.06,10.13l17.25,9.8c1.44.81,2.87,1.65,4.32,2.44l4.37,2.34,8.74,4.69,8.74,4.69c2.93,1.52,5.91,3,8.86,4.46l8.87,4.44c3,1.46,5.88,3,8.9,4.37l18,8.34a728.34,728.34,0,0,0,74,28.65h0a.5.5,0,1,1-.3.95,722.71,722.71,0,0,1-74.51-27.7l-18.11-8.23c-3-1.32-6-2.87-9-4.31L604,1145c-3-1.48-6-2.9-8.91-4.41l-8.8-4.63-8.8-4.64-4.4-2.31c-1.47-.78-2.9-1.61-4.35-2.42l-17.34-9.73c-5.75-3.3-11.41-6.75-17.13-10.12-2.84-1.7-5.71-3.37-8.53-5.1l-8.44-5.26-8.43-5.27-4.22-2.63-4.17-2.71-16.65-10.87c-5.52-3.66-11-7.43-16.47-11.14-2.73-1.88-5.5-3.7-8.2-5.61l-8.12-5.74c-5.39-3.86-10.86-7.61-16.17-11.57l-16-11.76L403,1017c-5.31-4-10.48-8.11-15.72-12.16l-7.84-6.11-7.76-6.21q-31.08-24.81-61-50.95c-19.95-17.43-39.63-35.2-58.85-53.44q-14.38-13.7-28.51-27.69c-4.68-4.69-9.35-9.38-14-14.13l-6.89-7.16L199,835.57c-1.12-1.24-2.25-2.39-3.37-3.77a.48.48,0,0,1,.08-.69.49.49,0,0,1,.69.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1952.26,653.7a6,6,0,0,1,6.14,9.81c-41.77,43-147.74,159.21-180.07,262-52.63,167.38-195,341.21-327.37,330.5C1451,1256,1309.74,862.54,1952.26,653.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1887.54,706.28c-1.24.92-2.53,2-3.81,3.05l-3.79,3.19-7.53,6.47c-5,4.34-9.94,8.74-14.88,13.15q-14.76,13.27-29.23,26.87-29,27.15-56.88,55.41c-37.14,37.71-73,76.67-106.9,117.34-4.3,5-8.4,10.23-12.59,15.34l-6.27,7.69c-2.1,2.56-4.11,5.18-6.17,7.77-4.08,5.21-8.22,10.37-12.26,15.6l-12,15.81-3,4-2.92,4-5.84,8-5.83,8c-1.93,2.69-3.79,5.43-5.68,8.14-3.76,5.44-7.59,10.83-11.28,16.32l-11,16.54c-.91,1.38-1.84,2.75-2.73,4.14l-2.64,4.2-5.27,8.4-5.28,8.4c-1.72,2.82-3.37,5.69-5.06,8.53l-5,8.55c-1.65,2.86-3.41,5.66-5,8.58l-9.56,17.39a734.35,734.35,0,0,0-33.63,71.84h0a.49.49,0,0,1-.65.28.5.5,0,0,1-.28-.64,721.34,721.34,0,0,1,32.74-72.45l9.44-17.5c1.53-3,3.27-5.77,4.91-8.65l5-8.6c1.68-2.87,3.31-5.76,5-8.6l5.22-8.46,5.23-8.46,2.61-4.24c.88-1.4,1.8-2.77,2.7-4.17l10.9-16.63c3.68-5.52,7.52-10.93,11.27-16.39,1.89-2.72,3.74-5.47,5.67-8.17l5.83-8.06,5.83-8,2.91-4,3-4,12-15.87c4-5.27,8.16-10.45,12.24-15.67,2.06-2.6,4.07-5.23,6.16-7.81l6.28-7.7c4.21-5.12,8.33-10.31,12.65-15.34l12.82-15.2,13.06-15c4.31-5,8.8-9.9,13.2-14.86l6.64-7.4,6.72-7.32q26.88-29.31,55-57.41T1827,757.59q14.65-13.43,29.58-26.55,7.49-6.54,15-13l7.61-6.39,3.84-3.16c1.32-1,2.55-2.08,4-3.1a.5.5,0,0,1,.69.12.5.5,0,0,1-.11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M791.24,1304.47s-40.57-65.5-147-93.16c-98.76-25.67-336.2-79.76-418.44-138.8a4.14,4.14,0,0,0-6,5.41c24.05,41.67,92.49,141.28,225,202.19C615.72,1358.65,791.24,1304.47,791.24,1304.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M293.87,1132.29a145.56,145.56,0,0,0,10.94,11.55c3.81,3.68,7.77,7.21,11.81,10.64s8.22,6.69,12.42,9.92,8.55,6.26,12.91,9.26a382.4,382.4,0,0,0,55.19,31.3c4.77,2.28,9.64,4.37,14.47,6.52,4.9,2,9.76,4.11,14.72,6,9.84,3.88,19.88,7.26,29.94,10.54l7.59,2.32,3.79,1.16,3.83,1.06,7.64,2.14c2.56.69,5.13,1.31,7.69,2,5.12,1.33,10.29,2.55,15.45,3.76l15.49,3.66c20.7,4.71,41.43,9.25,62.26,13.38,10.4,2.13,20.83,4.09,31.25,6.11l31.29,6c10.43,2,20.88,3.94,31.3,6l7.82,1.54,7.81,1.62c2.61.55,5.21,1.06,7.81,1.64l7.78,1.78c5.2,1.14,10.34,2.53,15.5,3.83,2.59.62,5.13,1.41,7.69,2.14s5.13,1.45,7.66,2.27a189.59,189.59,0,0,1,29.58,12.07.5.5,0,0,1-.43.9h0l-7.22-3.29-1.81-.82c-.6-.27-1.23-.47-1.85-.71l-3.71-1.39c-4.91-2-10-3.43-15-5.06-2.54-.76-5.11-1.4-7.66-2.11s-5.1-1.41-7.69-2c-5.17-1.19-10.31-2.47-15.51-3.5-20.75-4.39-41.66-8.07-62.58-11.8L610.6,1267c-10.44-2-20.88-3.93-31.3-6-20.87-4.08-41.65-8.57-62.4-13.23l-15.52-3.63-7.77-1.81c-2.59-.61-5.16-1.31-7.74-2s-5.17-1.3-7.74-2l-7.69-2.18-3.84-1.1-3.82-1.18-7.64-2.37c-10.13-3.32-20.2-6.82-30.08-10.84-5-1.91-9.85-4.08-14.76-6.14-4.85-2.22-9.74-4.35-14.5-6.74a383.53,383.53,0,0,1-55-32.49,291.55,291.55,0,0,1-24.94-19.94,181.7,181.7,0,0,1-22.1-23,.06.06,0,1,1,.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M749.37,694.29s41.39-65,20.09-172.89C749.7,421.29,695.33,183.92,712.81,84.2a4.14,4.14,0,0,0-7.5-3.08c-27.09,39.76-87.1,144.66-84.42,290.51C624.36,559.7,749.37,694.29,749.37,694.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M688.52,171.49a148,148,0,0,0-5.66,14.86c-1.66,5-3.12,10.14-4.45,15.27s-2.47,10.3-3.55,15.49-1.92,10.42-2.73,15.65a382.18,382.18,0,0,0-4.23,63.31c0,5.29.24,10.58.41,15.86.32,5.29.53,10.57,1,15.84.78,10.56,2.09,21.07,3.51,31.55l1.2,7.85.61,3.92.7,3.91,1.4,7.81c.48,2.6,1,5.19,1.57,7.78,1,5.19,2.17,10.37,3.32,15.55l3.43,15.54c4.75,20.69,9.66,41.34,15,61.89,2.59,10.29,5.36,20.54,8.06,30.81l8.2,30.78c2.73,10.27,5.51,20.52,8.17,30.81l2,7.72,1.93,7.74c.64,2.58,1.31,5.15,1.91,7.74L732.1,607c1.24,5.17,2.22,10.41,3.29,15.62.56,2.6,1,5.24,1.41,7.87s.91,5.24,1.28,7.88a189,189,0,0,1,2,31.89.5.5,0,0,1-1,0v0l-.18-7.93,0-2c0-.66-.11-1.32-.16-2l-.36-4c-.35-5.28-1.26-10.5-2-15.74-.41-2.61-1-5.21-1.43-7.81s-.93-5.21-1.55-7.79c-1.16-5.17-2.24-10.36-3.58-15.49-5-20.6-10.82-41-16.54-61.5l-8.55-30.7c-2.73-10.27-5.53-20.52-8.15-30.82-5.39-20.57-10.36-41.24-15.17-62L677.89,407l-1.74-7.78c-.58-2.59-1.06-5.22-1.6-7.83s-1.06-5.22-1.54-7.84l-1.37-7.88L671,371.7l-.59-4-1.18-7.9c-1.4-10.57-2.63-21.17-3.3-31.81-.44-5.31-.6-10.64-.87-16-.1-5.33-.32-10.66-.23-16a385.36,385.36,0,0,1,5.39-63.64,292.85,292.85,0,0,1,7.13-31.13,182.38,182.38,0,0,1,11.11-29.88.06.06,0,0,1,.08,0A.08.08,0,0,1,688.52,171.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1391.62,397.71a6.94,6.94,0,0,1-7.74-6.17c-.37-3.38-.36-3.81-.11-11.1.24-7,.73-21.6,1.39-53.27a72.07,72.07,0,0,1,76.26-70.45l275.71,16.11a7,7,0,0,1-.81,14L1460.6,270.7a58.07,58.07,0,0,0-61.44,56.76c-.66,31.77-1.16,46.41-1.4,53.45-.23,6.7-.23,6.7,0,9.06A7,7,0,0,1,1391.62,397.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1701.35,986h0a2,2,0,0,1-2-2l.08-6a2,2,0,0,1,2-2,2,2,0,0,1,2,2l-.08,6A2,2,0,0,1,1701.35,986Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1701.58,968.15h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,0,1,2-2,2,2,0,0,1,2,2l-.15,11.88A2,2,0,0,1,1701.58,968.15Zm.31-23.76h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,0,1,2-2,2,2,0,0,1,2,2l-.15,11.88A2,2,0,0,1,1701.89,944.39Zm.31-23.75h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,0,1,4,.06l-.15,11.87A2,2,0,0,1,1702.2,920.64Zm.3-23.76h0a2,2,0,0,1-2-2l.16-11.87a2,2,0,1,1,4,0l-.16,11.88A2,2,0,0,1,1702.5,896.88Zm.31-23.76h0a2,2,0,0,1-2-2l.16-11.88a2,2,0,0,1,4,0l-.16,11.88A2,2,0,0,1,1702.81,873.12Zm.31-23.75h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,0,1,2-2,2,2,0,0,1,2,2l-.15,11.88A2,2,0,0,1,1703.12,849.37Zm.31-23.76h0a2,2,0,0,1-2-2l.15-11.87a2,2,0,0,1,2-2,2,2,0,0,1,2,2l-.15,11.88A2,2,0,0,1,1703.43,825.61Zm.31-23.76h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,1,1,4,0l-.15,11.88A2,2,0,0,1,1703.74,801.85Zm.3-23.75h0a2,2,0,0,1-2-2l.16-11.88a2,2,0,0,1,4,0l-.16,11.88A2,2,0,0,1,1704,778.1Zm.31-23.76h0a2,2,0,0,1-2-2l.16-11.88a2,2,0,0,1,4,.06l-.16,11.87A2,2,0,0,1,1704.35,754.34Zm.31-23.76h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,1,1,4,.05l-.15,11.88A2,2,0,0,1,1704.66,730.58Zm.31-23.76h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,0,1,4,.05l-.15,11.88A2,2,0,0,1,1705,706.82Zm.31-23.75h0a2,2,0,0,1-2-2l.16-11.88a2,2,0,0,1,4,.05l-.16,11.88A2,2,0,0,1,1705.28,683.07Zm.3-23.76h0a2,2,0,0,1-2-2l.16-11.88a2,2,0,0,1,4,.06l-.16,11.88A2,2,0,0,1,1705.58,659.31Zm.31-23.76h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,1,1,4,.05l-.15,11.88A2,2,0,0,1,1705.89,635.55Zm.31-23.75h0a2,2,0,0,1-2-2l.15-11.88a2,2,0,0,1,4,.05l-.15,11.88A2,2,0,0,1,1706.2,611.8Zm.31-23.76h0a2,2,0,0,1-2-2l0-2.44a54.58,54.58,0,0,1,1-9.73,2,2,0,0,1,3.93.76,50.24,50.24,0,0,0-.9,9l0,2.44A2,2,0,0,1,1706.51,588Zm4.52-23.13a1.93,1.93,0,0,1-.81-.17,2,2,0,0,1-1-2.64,54.46,54.46,0,0,1,6.27-10.6,2,2,0,0,1,3.19,2.42,50.24,50.24,0,0,0-5.8,9.81A2,2,0,0,1,1711,564.91Zm14.21-18.78a2,2,0,0,1-1.53-.72,2,2,0,0,1,.25-2.81,53.82,53.82,0,0,1,10.27-6.77,2,2,0,1,1,1.81,3.57,49.89,49.89,0,0,0-9.52,6.27A2,2,0,0,1,1725.24,546.13Zm175.25-7.68h-.06l-11.88-.37a2,2,0,0,1,.13-4l11.87.37a2,2,0,0,1-.06,4Zm11.84-.5a2,2,0,0,1-.3-4,49.23,49.23,0,0,0,11-3,2,2,0,0,1,1.49,3.71,53.76,53.76,0,0,1-11.88,3.25Zm-35.58-.24h-.07l-11.87-.38a2,2,0,1,1,.12-4l11.88.37a2,2,0,0,1-.06,4ZM1853,537h-.07l-11.87-.37a2,2,0,0,1-1.94-2.06,2,2,0,0,1,2.07-1.94l11.87.37a2,2,0,0,1-.06,4Zm-23.75-.74h-.06l-11.88-.38a2,2,0,0,1,.13-4l11.87.38a2,2,0,0,1-.06,4Zm-83-.72a2,2,0,0,1-.47-3.94A53.7,53.7,0,0,1,1758,530a2,2,0,0,1,2,2,2,2,0,0,1-2,2,50,50,0,0,0-11.31,1.42A1.83,1.83,0,0,1,1746.25,535.5Zm59.25,0h-.06l-11.87-.37a2,2,0,1,1,.12-4l11.88.37a2,2,0,0,1-.07,4Zm-23.74-.74h-.07l-11.87-.37a2,2,0,1,1,.12-4l11.88.38a2,2,0,0,1-.06,4Zm152.44-5.55a2,2,0,0,1-1.15-3.64,50.26,50.26,0,0,0,8.54-7.55,2,2,0,1,1,3,2.68,54.59,54.59,0,0,1-9.22,8.15A2,2,0,0,1,1934.2,529.18ZM1950,511.69a2,2,0,0,1-1.74-3,49.63,49.63,0,0,0,4.35-10.53,2,2,0,0,1,3.85,1.1,54,54,0,0,1-4.71,11.37A2,2,0,0,1,1950,511.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1956.42,489h-.09a2,2,0,0,1-1.91-2.09,50.52,50.52,0,0,0-.06-5.77,2,2,0,0,1,4-.27,56.3,56.3,0,0,1,.07,6.23A2,2,0,0,1,1956.42,489Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1628,823.37a334.61,334.61,0,0,0,4.94-91.18c-6.54-75.5-39.9-138.51-96.9-183.61a181.57,181.57,0,0,0,2.34-60c-5.3-41.15-27.7-99.12-103-146.83-7.7-24.19-30-68.3-93.43-103-47.1-25.74-91.76-31.92-125.74-17.41a79.56,79.56,0,0,0-34,27.15,69.33,69.33,0,0,0-29.61,13c-11.54,8.78-20.38,21-26.55,36.58-6.17-15.54-15-27.8-26.55-36.58a69.33,69.33,0,0,0-29.61-13,79.48,79.48,0,0,0-34-27.15c-34-14.51-78.64-8.33-125.74,17.41-63.47,34.69-85.72,78.8-93.43,103-75.33,47.71-97.73,105.68-103,146.83a181.57,181.57,0,0,0,2.34,60c-57,45.11-90.36,108.11-96.9,183.61a334.63,334.63,0,0,0,4.94,91.18c-36.87,41.77-44.88,131.94-18.29,233.65,14,53.58,38,92.83,71.24,116.66a128.74,128.74,0,0,0,16.81,10.22,68,68,0,0,0,7.47,29.54c27.36,54.63,124.58,83.77,208.78,88.42q6.42.36,12.59.35c41.42,0,74.27-12,97.79-35.67,18.37-18.52,26.9-40.21,30.8-57.78,33.23-4.06,57.48-16.12,72.3-36,.88-1.18,1.67-2.37,2.45-3.55.78,1.18,1.57,2.37,2.45,3.54,14.82,19.92,39.07,32,72.3,36,3.9,17.57,12.43,39.26,30.8,57.77,23.52,23.71,56.37,35.68,97.79,35.68q6.16,0,12.59-.35c84.2-4.65,181.42-33.79,208.78-88.42a68,68,0,0,0,7.47-29.54,128.08,128.08,0,0,0,16.81-10.22c33.26-23.83,57.23-63.08,71.24-116.66C1672.9,955.31,1664.89,865.14,1628,823.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1104.29,363.45V1116.6s19.36,62.36-82.18,61.36c0,0,6.18,98-110.18,91.62s-212.18-57.07-179-107c0,0-66.75-2.67-95.79-113.77s-11.18-195.46,23-213.63c0,0-54.36-176,93.34-273.81,0,0-50.88-116.9,91.52-198.94,0,0,5.95-54.46,80.74-95.34,70.28-38.41,115.39-18.87,124.08,13.38C1049.8,280.51,1104.29,265.44,1104.29,363.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1147.87,363.45V1116.6s-19.36,62.36,82.18,61.36c0,0-6.18,98,110.18,91.62s212.18-57.07,179-107c0,0,66.75-2.67,95.79-113.77s11.18-195.46-23-213.63c0,0,54.36-176-93.34-273.81,0,0,50.88-116.9-91.52-198.94,0,0-6-54.46-80.74-95.34-70.28-38.41-115.39-18.87-124.08,13.38C1202.36,280.51,1147.87,265.44,1147.87,363.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1041.87,371.74a1.58,1.58,0,0,1-.38,0c-.44-.08-43.33-8.85-38.15-52,4.91-40.8,45.77-41.2,46.47-41.2h0a2,2,0,0,1,0,4h0c-1.94,0-38,.53-42.45,37.68-2,16.56,3.26,29.59,15.59,38.71a53.57,53.57,0,0,0,19.34,8.87,2,2,0,0,1-.37,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M954.77,514.36a67.08,67.08,0,0,1-24-4.41c-10-3.94-16.27-9.73-17.13-15.88a2,2,0,1,1,4-.55c.65,4.61,6.12,9.36,14.64,12.71,14.67,5.76,35.88,6.42,48-3.48,8.21-6.7,11.13-17.2,8.7-31.22-7.86-45.26-46.92-48.85-88.27-52.64-9.17-.84-18.64-1.71-27.86-3.05-17.21-2.48-28.13-8.57-32.47-18.09-6.13-13.47,3.37-28.46,3.78-29.1a2,2,0,0,1,3.36,2.17c-.12.19-8.71,13.85-3.49,25.29,3.74,8.19,13.63,13.5,29.39,15.78,9.12,1.31,18.54,2.18,27.65,3,42.93,3.94,83.47,7.66,91.85,55.94,3.36,19.36-3.64,29.72-10.11,35C975.46,511.85,965.17,514.36,954.77,514.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M858.27,646.07c-9.13,0-16.92-3.72-19.62-10a2,2,0,1,1,3.67-1.58c2.63,6.09,13.06,9.09,23.24,6.69,6-1.43,25.56-8.34,23.92-37.4-1-18.14-7.29-31.12-18.12-37.55-13.24-7.85-33.44-6-56.87,5.1-44.14,21-58.3-2-58.88-3a2,2,0,0,1,3.44-2c.53.87,13.1,20.74,53.73,1.42,25-11.89,46-13.6,60.62-4.92,12,7.14,19,21.23,20.07,40.77,1.45,25.56-13,38.2-27,41.51A35.76,35.76,0,0,1,858.27,646.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M821.81,778.64a56.65,56.65,0,0,1-8.91-.7c-18-2.87-33.44-14.59-45.87-34.84s-16.23-39.94-11.2-58.38c8.53-31.22,39-47.62,40.25-48.3A2,2,0,1,1,798,640c-.3.16-30.21,16.32-38.27,45.86-4.72,17.32-1.1,35.89,10.76,55.19s26.28,30.3,43.07,33c28.88,4.62,55.22-17.37,55.48-17.59a2,2,0,0,1,2.59,3.05C870.56,760.3,848.63,778.63,821.81,778.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1022,792.48a2,2,0,0,1-.9-.22,2,2,0,0,1-.88-2.69c.12-.25,12.55-26.24-13.81-68.34s-76.37-32.9-76.87-32.8a2,2,0,0,1-.76-3.93,88.52,88.52,0,0,1,30,.45c15.28,2.77,36.55,10.95,51.07,34.16,27.65,44.18,14.56,71.14,14,72.27A2,2,0,0,1,1022,792.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M961.41,932.51a2,2,0,0,1-1.3-3.52c7-6,15-15.86,13.74-29.22-1.68-17.44-19.18-36-50.61-53.78-34.25-19.33-62.45-24.42-83.81-15.13-24.61,10.7-31.28,37.28-31.35,37.55a2,2,0,0,1-3.88-.94c.28-1.17,7.22-28.8,33.64-40.28,22.57-9.82,52-4.66,87.36,15.32,33.09,18.67,50.79,37.81,52.63,56.88,1.46,15.07-7.42,26.07-15.13,32.64A2,2,0,0,1,961.41,932.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1002.21,1068.45a52.8,52.8,0,0,1-45.28-25.52,2,2,0,1,1,3.43-2,48.73,48.73,0,0,0,59.75,20.09c25.39-10.31,35.2-39,26.22-76.79-12.3-51.77-12.7-83.67-1.27-100.39,5.52-8.06,13.61-12.58,25.46-14.22,27.78-3.85,35.25,10.45,35.56,11.06a2,2,0,0,1-3.57,1.8c-.29-.55-6.77-12.32-31.44-8.9-10.66,1.48-17.87,5.45-22.7,12.52-10.61,15.5-10,47.3,1.85,97.2,5,21.19,4.49,39.4-1.61,54.12-5.34,12.86-14.67,22.3-27,27.31A51.59,51.59,0,0,1,1002.21,1068.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M812.59,996.24c-40.88,0-60.89-59.31-77.34-108-4.33-12.84-8.43-25-12.62-35.28-6.84-16.8-15.55-26.53-25.88-28.9-14.91-3.43-28.41,9.69-28.55,9.82a1.88,1.88,0,0,1-2.82-.14,2.33,2.33,0,0,1,.13-3.08c.62-.6,15.18-14.74,32.06-10.86,11.67,2.68,21.33,13.25,28.72,31.4,4.24,10.43,8.36,22.63,12.72,35.54,9.09,27,19.41,57.51,33.48,78.53,15.78,23.57,34,31.37,55.52,23.85,18.24-6.37,29.07-15.82,32.21-28.1,5-19.8-11.65-40.87-11.82-41.08a2.31,2.31,0,0,1,.18-3.07,1.88,1.88,0,0,1,2.82.21c.75.92,18.3,23,12.68,45.09-3.51,13.79-15.24,24.25-34.85,31.09A50.42,50.42,0,0,1,812.59,996.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M737.55,1160.28a2,2,0,0,1-1-.27,2,2,0,0,1-.74-2.73c33.91-58.87,85.15-77.57,85.67-77.75a2,2,0,1,1,1.33,3.77c-.5.17-50.4,18.45-83.53,76A2,2,0,0,1,737.55,1160.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1017.43,1174.08a2,2,0,0,1-1.4-.57c-22.2-21.69-45.65-18.29-68.33-15-20.84,3-40.52,5.88-57.6-10.34-12.93-12.28-19.23-25.76-18.72-40.06.91-26.1,24-45.39,24.93-46.2a2,2,0,0,1,2.55,3.09c-.23.18-22.65,19-23.49,43.27-.45,13.1,5.43,25.55,17.48,37,15.68,14.88,34.43,12.16,54.27,9.28,22.55-3.27,48.1-7,71.71,16.1a2,2,0,0,1,0,2.82A2,2,0,0,1,1017.43,1174.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1247.74,377.27a63,63,0,0,1-25.18-5.7c-15-6.53-24.87-16.48-29.46-29.57-9.12-26,5.76-54.81,6.4-56a2,2,0,1,1,3.54,1.85c-.15.29-14.71,28.56-6.16,52.86,4.21,12,13.39,21.15,27.28,27.21a58.65,58.65,0,0,0,23.5,5.33c16.31,0,28.51-8.49,34.6-19.57,7.06-12.85,5-26.55-5.06-33.31a2,2,0,1,1,2.23-3.32c11.82,8,14.43,23.82,6.33,38.56C1279,367.84,1265.6,377.27,1247.74,377.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1288.38,454.52a2,2,0,0,1-1.89-1.34c-.32-.91-7.69-22.55,3.68-37.84,7.58-10.21,21.57-14.94,41.57-14.06,36,1.58,58-2.3,67.19-11.86,4.13-4.28,5.84-9.92,5.25-17.23a2,2,0,0,1,4-.32c.69,8.52-1.39,15.17-6.36,20.32-10.2,10.58-32.52,14.74-70.25,13.09-18.59-.82-31.44,3.37-38.18,12.45-10.11,13.6-3.18,33.93-3.11,34.13a2,2,0,0,1-1.23,2.55A1.91,1.91,0,0,1,1288.38,454.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1194.11,554.52h-.5a2,2,0,1,1,.08-4h.41c12.86,0,27.23-11.13,35.08-27.23,9.12-18.71,7.37-38.73-4.68-53.56-8.76-10.78-17.53-16.05-26-15.65-11.55.54-19,11.48-19.08,11.59a2,2,0,1,1-3.32-2.22c.34-.52,8.6-12.71,22.18-13.36,9.86-.48,19.76,5.29,29.37,17.12,13.06,16.07,15,37.69,5.18,57.83C1224.15,542.74,1208.67,554.52,1194.11,554.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1382.42,591.42c-12,0-27-3.55-44.81-14.45-15.06-9.24-25.79-22-31-36.85a66.18,66.18,0,0,1-1.19-39.59c5.3-18.75,17.79-31.34,31.07-31.34h0c10.78,0,18.47,2.83,22.86,8.39,5.55,7,3.57,15.71,3.48,16.08a2,2,0,0,1-3.89-.92c0-.11,1.59-7.24-2.75-12.71-3.6-4.53-10.23-6.83-19.7-6.84h0c-11.3,0-22.49,11.69-27.22,28.43-6.21,21.94-1.47,52.37,30.44,71.94,22.36,13.71,43.55,17.35,61.26,10.51a47.78,47.78,0,0,0,20.11-14.4,2,2,0,0,1,3.24,2.34c-.3.41-7.51,10.24-21.91,15.79A55.17,55.17,0,0,1,1382.42,591.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1379.31,785.2c-13.66,0-30.6-4.66-49.71-19.69-29.36-23.07-30.13-51.46-25.6-71.21a108.68,108.68,0,0,1,16.89-37.38,2,2,0,1,1,3.2,2.4,106.87,106.87,0,0,0-16.22,36c-6.15,27,2,49.59,24.2,67s44,22.9,64.59,16a59.78,59.78,0,0,0,24.5-15.74,2,2,0,0,1,3.06,2.58,62.77,62.77,0,0,1-26.11,16.89A58.53,58.53,0,0,1,1379.31,785.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1483.2,722c-11.42,0-23.9-5.07-35.91-15-25.85-21.31-33-52.92-28.56-74.79,3.55-17.61,14.21-30.29,29.26-34.8,36.1-10.84,43.38-29.73,43.45-29.92a2,2,0,0,1,3.77,1.35c-.31.85-7.83,20.92-46.07,32.4-13.59,4.07-23.24,15.65-26.49,31.76-4.18,20.7,2.61,50.66,27.19,70.92,18.1,14.92,37.16,18.16,51,8.66,9.28-6.39,13.6-17.3,10.5-26.54a2,2,0,0,1,3.79-1.27c3.66,10.92-1.28,23.71-12,31.1A34.53,34.53,0,0,1,1483.2,722Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1436.54,973.41h-.28c-14.15-.08-24.88-4.22-31.9-12.31-11-12.63-8.74-30.12-8.64-30.86a2,2,0,0,1,4,.53h0c0,.17-2.06,16.49,7.73,27.74,6.23,7.15,15.94,10.82,28.88,10.9,41.76.24,76.58-65.17,84.06-92.49.58-2.11,1.15-4.33,1.73-6.61,4.07-15.93,9.14-35.76,24.52-42.82,10.77-4.94,24.76-3,42.76,5.94a2,2,0,1,1-1.77,3.58c-16.86-8.36-29.72-10.29-39.32-5.88-13.65,6.26-18.25,24.27-22.31,40.17-.59,2.31-1.17,4.55-1.75,6.67C1517.5,902.48,1482.91,973.41,1436.54,973.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1274,1050.85a1.84,1.84,0,0,1-.51-.07c-25.93-6.81-46.7-17.86-61.74-32.84a90.65,90.65,0,0,1-25.42-47.27c-8.26-41.45,11.13-81.95,33.56-99,16.33-12.42,35.72-15.3,57.63-8.57,17.42,5.35,31.46,15.24,38.21,20,1.29.91,2.61,1.84,3.06,2.08a2,2,0,0,1-.73,3.92c-.85-.09-1.54-.55-4.63-2.73-36.61-25.77-67.26-29.64-91.12-11.51-21.77,16.55-39.71,56.62-32.06,95,5.26,26.43,24.15,61.25,84.26,77a2,2,0,0,1-.51,3.94Zm44.45-165.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1231.16,1174.07a2,2,0,0,1-2-2,38.87,38.87,0,0,1,11.46-26.15c10.53-10.64,27-15.93,49-15.73,41.09.37,70-8.63,77.35-24.09,4.79-10.11.73-23.05-12.09-38.47a2,2,0,1,1,3.07-2.56c13.91,16.72,18.16,31.1,12.63,42.75-8.14,17.15-37.63,26.76-81,26.37-20.86-.2-36.34,4.68-46.08,14.48a35.52,35.52,0,0,0-10.37,23.32,2,2,0,0,1-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1514.63,1161.59a2,2,0,0,1-1.85-1.24c-12.65-30.62-33.13-46.78-48.08-54.94-16.25-8.87-29.7-10.5-29.83-10.52a2,2,0,0,1,.45-4c.57.06,14.22,1.7,31.13,10.89,15.58,8.47,36.9,25.23,50,57a2,2,0,0,1-1.08,2.61A1.9,1.9,0,0,1,1514.63,1161.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 676.75,
    cy: 547.75,
    r: 76.26,
    transform: "translate(-189.1 638.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M606.45,545h-.05a1,1,0,0,1-.95-1,72.88,72.88,0,0,1,1-9,1,1,0,0,1,2,.36,68.88,68.88,0,0,0-1,8.72A1,1,0,0,1,606.45,545Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M613.87,517.07a.91.91,0,0,1-.45-.11,1,1,0,0,1-.44-1.34,71.09,71.09,0,0,1,63.77-39.27,71.91,71.91,0,0,1,12.88,1.16,1,1,0,1,1-.35,2,69.93,69.93,0,0,0-12.53-1.13,69.12,69.12,0,0,0-62,38.17A1,1,0,0,1,613.87,517.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 678.42,
    cy: 549.41,
    r: 64.55,
    transform: "translate(-12.17 1083.45) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M698.18,525c0,10.93-8.86,22.73-19.79,22.73S658.6,536,658.6,525s8.86-18.68,19.79-18.68S698.18,514.09,698.18,525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M653.83,589.83h48.31a11.71,11.71,0,0,0,11.14-8.13l2.6-8.13A11.69,11.69,0,0,0,708.82,559c-19.66-7.19-40-6.27-60.82.66a11.65,11.65,0,0,0-7.46,14.12l2,7.38A11.71,11.71,0,0,0,653.83,589.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 780.96,
    cy: 383.28,
    r: 64.53,
    transform: "translate(228.5 1055.29) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M721.48,381.12h-.05a1,1,0,0,1-.95-1.05,60.51,60.51,0,0,1,.88-7.61,1,1,0,0,1,1.16-.8,1,1,0,0,1,.81,1.16,58.45,58.45,0,0,0-.85,7.35A1,1,0,0,1,721.48,381.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M727.75,357.48a1.06,1.06,0,0,1-.45-.11,1,1,0,0,1-.44-1.34A60.3,60.3,0,0,1,781,322.72a61.37,61.37,0,0,1,10.93,1,1,1,0,0,1-.36,2,59.19,59.19,0,0,0-10.57-.95,58.31,58.31,0,0,0-52.31,32.21A1,1,0,0,1,727.75,357.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 782.37,
    cy: 384.69,
    r: 54.61,
    transform: "translate(-42.87 665.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M799.09,364.05c0,9.25-7.5,19.23-16.75,19.23s-16.74-10-16.74-19.23,7.5-15.81,16.74-15.81S799.09,354.81,799.09,364.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M761.57,418.89h40.87a9.89,9.89,0,0,0,9.42-6.88l2.2-6.88a9.87,9.87,0,0,0-6-12.29c-16.63-6.09-33.83-5.31-51.45.56a9.85,9.85,0,0,0-6.32,11.94l1.7,6.24A9.9,9.9,0,0,0,761.57,418.89Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1861.24,
    cy: 337.76,
    rx: 168.74,
    ry: 153.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1861.24,
    cy: 337.76,
    rx: 163.12,
    ry: 147.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1710.87,331.51h-.06a1,1,0,0,1-.94-1.06,127.11,127.11,0,0,1,2.2-17.29,1,1,0,0,1,2,.39,121.68,121.68,0,0,0-2.17,17A1,1,0,0,1,1710.87,331.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1726.73,277.29a1.11,1.11,0,0,1-.49-.12,1,1,0,0,1-.38-1.36c12.46-22.4,31.44-41.3,54.88-54.66a162.68,162.68,0,0,1,80.5-21,168.06,168.06,0,0,1,27.33,2.23,1,1,0,1,1-.33,2,166.24,166.24,0,0,0-27-2.2c-56.82,0-108,28.59-133.64,74.61A1,1,0,0,1,1726.73,277.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1864.8,
    cy: 340.98,
    rx: 138.06,
    ry: 125.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1776.09,463a19.81,19.81,0,0,1-23.62-15.08l-36.29-164.58a17.46,17.46,0,0,1,12.43-20.59L1964.53,198a12.87,12.87,0,0,1,15.93,9.42l45,187.86a12.22,12.22,0,0,1-9.25,14.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1757.44,453a5.75,5.75,0,0,1-7-5.14c-1.91-23.15-9.53-102.51-28.52-165.32a5.32,5.32,0,0,1,3.67-6.68l236.85-65.58a6.12,6.12,0,0,1,7.53,4.23c7.52,26.52,38.07,135.84,42.64,176.23a4.85,4.85,0,0,1-3.76,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1762.86,449a5.55,5.55,0,0,1-6.75-4.95c-1.83-22.27-9.16-98.65-27.44-159.1a5.12,5.12,0,0,1,3.53-6.42l227.94-63.12a5.9,5.9,0,0,1,7.24,4.08c7.24,25.52,36.64,130.72,41,169.59a4.67,4.67,0,0,1-3.61,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1758.17,283.57l-2.19.49a4.44,4.44,0,0,1-5.27-3.37l-7.07-32.07a4.43,4.43,0,0,1,1.77-4.57l4.18-2.94a4.42,4.42,0,0,1,6.92,3l5.09,34.53A4.43,4.43,0,0,1,1758.17,283.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1802.65,271.25l-2.19.48a4.41,4.41,0,0,1-5.27-3.37l-7.07-32.06a4.4,4.4,0,0,1,1.77-4.57l4.18-2.95a4.43,4.43,0,0,1,6.92,3l5.08,34.52A4.42,4.42,0,0,1,1802.65,271.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1862.66,258l-2.19.48a4.41,4.41,0,0,1-5.27-3.37l-7.07-32.07a4.39,4.39,0,0,1,1.77-4.56l4.18-2.95a4.43,4.43,0,0,1,6.92,3l5.08,34.53A4.42,4.42,0,0,1,1862.66,258Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1922,241.54l-2.19.48a4.42,4.42,0,0,1-5.27-3.36l-7.07-32.07a4.44,4.44,0,0,1,1.77-4.57l4.18-2.94a4.42,4.42,0,0,1,6.92,3l5.09,34.53A4.42,4.42,0,0,1,1922,241.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1872.7,285.65l3.67,16.63a4.66,4.66,0,0,0,5.62,3.53l17-4a4.64,4.64,0,0,0,3.47-5.53l-3.85-17.48a4.65,4.65,0,0,0-5.84-3.47L1876,280.18A4.67,4.67,0,0,0,1872.7,285.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1818.48,321.08l17-4a4.66,4.66,0,0,0,3.48-5.53l-3.28-14.87a4.65,4.65,0,0,0-5.81-3.48L1813,297.91a4.66,4.66,0,0,0-3.29,5.49l3.12,14.16A4.66,4.66,0,0,0,1818.48,321.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1851.24,391.16l-16.18,3.77a5.08,5.08,0,0,0-3.81,6l3.35,15.19a5.08,5.08,0,0,0,6,3.89l16.3-3.23a5.08,5.08,0,0,0,4-6.08L1857.36,395A5.09,5.09,0,0,0,1851.24,391.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1828.81,417.19l-3.28-14.86a5,5,0,0,0-6-3.79l-16.35,3.81a5,5,0,0,0-3.74,5.93l3.16,14.33a5,5,0,0,0,5.84,3.82l16.47-3.27A5,5,0,0,0,1828.81,417.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1814,350.12l-2.69-12.2a5.38,5.38,0,0,0-6.53-4.06l-15.57,3.81a5.38,5.38,0,0,0-4,6.38l2.57,11.65a5.37,5.37,0,0,0,6.34,4.11l15.69-3.28A5.37,5.37,0,0,0,1814,350.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1821.83,385.56l-4.11-18.66a5,5,0,0,0-5.9-3.81l-16,3.35a5.37,5.37,0,0,0-4.15,6.42l4.15,18.81a5,5,0,0,0,6,3.77l16.31-4A5,5,0,0,0,1821.83,385.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1850.26,313.56l17-4a4.65,4.65,0,0,0,3.47-5.53l-3.57-16.2a4.65,4.65,0,0,0-5.8-3.48l-16.84,4.74a4.65,4.65,0,0,0-3.28,5.48l3.41,15.49A4.66,4.66,0,0,0,1850.26,313.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1853.55,377.77l-3.84-17.45a5.08,5.08,0,0,0-6-3.87l-16.26,3.39a5.07,5.07,0,0,0-3.93,6.06l4,18a5.07,5.07,0,0,0,6.15,3.84l16.15-3.92A5.07,5.07,0,0,0,1853.55,377.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1869.77,318l-18.53,4.53a3.86,3.86,0,0,0-2.84,4.58l3.7,16.77a3.85,3.85,0,0,0,4.55,2.94l18.66-3.89a3.85,3.85,0,0,0,3-4.6l-3.84-17.42A3.86,3.86,0,0,0,1869.77,318Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1880.33,320.25l3.52,16a4.86,4.86,0,0,0,5.72,3.7l16.73-3.49a4.84,4.84,0,0,0,3.74-5.78l-3.65-16.55a4.84,4.84,0,0,0-5.88-3.66l-16.6,4.06A4.85,4.85,0,0,0,1880.33,320.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1824.68,353.45l18.66-3.89a3.86,3.86,0,0,0,3-4.6l-3.6-16.32a3.85,3.85,0,0,0-4.68-2.91l-18.52,4.53a3.85,3.85,0,0,0-2.85,4.57l3.46,15.68A3.85,3.85,0,0,0,1824.68,353.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1875.68,349.78l-16.26,3.39a5.09,5.09,0,0,0-3.93,6.07l3.74,16.93a5.08,5.08,0,0,0,6.15,3.85l16.15-3.92a5.07,5.07,0,0,0,3.76-6l-3.61-16.41A5.08,5.08,0,0,0,1875.68,349.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1908.21,343l-17.4,3.63a4.5,4.5,0,0,0-3.48,5.37l3.76,17.05a4.5,4.5,0,0,0,5.46,3.4l17.27-4.19a4.49,4.49,0,0,0,3.33-5.34l-3.63-16.48A4.5,4.5,0,0,0,1908.21,343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1789,327.83l12.89-3.06a6.45,6.45,0,0,0,4.82-7.67l-2.36-10.68a5.75,5.75,0,0,0-7.17-4.29l-14.21,4a6.32,6.32,0,0,0-4.46,7.44l2,8.92A7.06,7.06,0,0,0,1789,327.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1793.81,410.1a5.37,5.37,0,0,0-6.47-4.07l-5.62,1.31c-4.28,1-7.08,4.66-6.29,8.22l2.27,10.33c.78,3.54,4.81,5.68,9.08,4.84l6.09-1.21a5,5,0,0,0,3.9-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1973.36,362.76l-11.06,2.58a5.08,5.08,0,0,0-3.82,6l4.27,19.35a5.08,5.08,0,0,0,6,3.89l11.1-2.2c4.43-.88,7.41-4.63,6.6-8.3l-3.66-16.59C1981.94,363.9,1977.72,361.75,1973.36,362.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1780.56,400.61l5.47-1.33a5.38,5.38,0,0,0,4-6.38l-4.18-19a5.37,5.37,0,0,0-6.34-4.11l-5.56,1.16c-4.38.91-7.31,4.64-6.51,8.28l3.66,16.59C1771.89,399.52,1776.17,401.67,1780.56,400.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1772.25,364.38l6.94-1.45a4.05,4.05,0,0,0,3.14-4.85l-3-13.7a4.06,4.06,0,0,0-4.93-3.07l-7,1.7c-4.22,1-7,4.67-6.18,8.2l1.84,8.35C1763.87,363.13,1768,365.27,1772.25,364.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1950.06,259.14l-11,3.09a4.84,4.84,0,0,0-3.42,5.7l4.22,19.11a4.84,4.84,0,0,0,5.84,3.67l11.41-2.7c4.26-1,7-4.67,6.25-8.22l-3.52-16C1959,260,1954.53,257.89,1950.06,259.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1883.05,383.77l-16.18,3.76a5.08,5.08,0,0,0-3.81,6l3.58,16.24a5.08,5.08,0,0,0,5.95,3.88l16.3-3.23a5.08,5.08,0,0,0,4-6.08l-3.7-16.76A5.08,5.08,0,0,0,1883.05,383.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1958.57,296.23,1947.36,299a4.86,4.86,0,0,0-3.58,5.75l4,18.17a4.85,4.85,0,0,0,5.72,3.7l11.35-2.36c4.38-.92,7.31-4.64,6.51-8.28l-3.31-15C1967.25,297.3,1963,295.15,1958.57,296.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1966.55,330.84l-11.8,2.46a4.5,4.5,0,0,0-3.48,5.37l3.3,15A4.5,4.5,0,0,0,1960,357l11.76-2.85c4.23-1,7-4.67,6.2-8.21l-2.28-10.32C1974.92,332.09,1970.84,329.94,1966.55,330.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1919.3,345.34l3.53,16a4.51,4.51,0,0,0,5.46,3.4l17.27-4.2a4.49,4.49,0,0,0,3.33-5.34l-3.4-15.44a4.49,4.49,0,0,0-5.31-3.43l-17.4,3.62A4.51,4.51,0,0,0,1919.3,345.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1946.66,369l-16.17,3.76a5.09,5.09,0,0,0-3.81,6l4,18.31a5.09,5.09,0,0,0,6,3.89l16.29-3.24a5.08,5.08,0,0,0,4-6.08l-4.15-18.83A5.08,5.08,0,0,0,1946.66,369Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1765.67,333.36l6.76-1.6a4.07,4.07,0,0,0,3-4.83l-3-13.4a4.05,4.05,0,0,0-5.07-3l-7.09,2c-4,1.14-6.62,4.69-5.86,8.12l1.76,8C1757.06,332.25,1761.3,334.39,1765.67,333.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1914.85,376.37l-15.9,3.7a5.36,5.36,0,0,0-4,6.38l3.75,17a5.09,5.09,0,0,0,6,3.9l16.29-3.24a5.08,5.08,0,0,0,4-6.08L1921,380.23A5.08,5.08,0,0,0,1914.85,376.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1904.19,276.79l3.92,17.78a4.84,4.84,0,0,0,5.84,3.67l16.63-3.94a4.84,4.84,0,0,0,3.61-5.76l-4.07-18.47a4.84,4.84,0,0,0-6-3.62l-16.47,4.63A4.85,4.85,0,0,0,1904.19,276.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1912.06,312.48l3.76,17.08a4.85,4.85,0,0,0,5.72,3.7l16.73-3.49A4.84,4.84,0,0,0,1942,324l-3.89-17.66a4.85,4.85,0,0,0-5.88-3.66l-16.6,4.06A4.84,4.84,0,0,0,1912.06,312.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1755.27,298.55l2.12,5.41a3.8,3.8,0,0,0,4.35,2.32l.26-.06a3.78,3.78,0,0,0,2.88-4.51l-1.27-5.77a3.79,3.79,0,0,0-5-2.74l-1.12.41A3.78,3.78,0,0,0,1755.27,298.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1780.92,290.79l2.13,5.42a3.79,3.79,0,0,0,4.34,2.31l.26-.06a3.78,3.78,0,0,0,2.89-4.51l-1.27-5.76a3.79,3.79,0,0,0-5-2.75l-1.12.41A3.78,3.78,0,0,0,1780.92,290.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1813,283.46l2.13,5.42a3.78,3.78,0,0,0,4.34,2.31l.26-.05a3.79,3.79,0,0,0,2.89-4.52l-1.27-5.76a3.79,3.79,0,0,0-5-2.75l-1.12.41A3.79,3.79,0,0,0,1813,283.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1843.85,274.5l2.13,5.41a3.78,3.78,0,0,0,4.34,2.32l.27-.06a3.78,3.78,0,0,0,2.88-4.51l-1.27-5.77a3.79,3.79,0,0,0-5-2.74l-1.12.4A3.8,3.8,0,0,0,1843.85,274.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1874.88,262.65l2.13,5.42a3.79,3.79,0,0,0,4.34,2.31l.26-.06a3.78,3.78,0,0,0,2.89-4.51l-1.27-5.76a3.79,3.79,0,0,0-5-2.75l-1.12.41A3.78,3.78,0,0,0,1874.88,262.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1909,255.13l2.13,5.42a3.78,3.78,0,0,0,4.34,2.32l.26-.06a3.79,3.79,0,0,0,2.89-4.52l-1.27-5.76a3.79,3.79,0,0,0-5-2.74l-1.12.4A3.78,3.78,0,0,0,1909,255.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1937.45,247.58l2.13,5.42a3.78,3.78,0,0,0,4.34,2.31l.27-.05a3.79,3.79,0,0,0,2.88-4.52L1945.8,245a3.79,3.79,0,0,0-5-2.75l-1.12.41A3.8,3.8,0,0,0,1937.45,247.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1907.43,324.84a1.4,1.4,0,0,0-2.51-.45c-2.13,2.72-2.41,6.19-3,9.51-.66,3.87-1.26,7.74-1.67,11.64a100.45,100.45,0,0,0-.59,12.37,85.09,85.09,0,0,0-9.64-12c-1-1-2.73.16-2,1.42,4.14,7.38,8.77,14.46,12.79,21.91,1.42,2.62,5.1,1,4.73-1.74a92.37,92.37,0,0,1-.1-22.6c.39-3.6.94-7.18,1.55-10.74C1907.53,331,1908.39,328,1907.43,324.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1912.47,329.83a1.84,1.84,0,0,0-.19,3.67c15.37,2.74,21.37,19.52,13.87,32.38-3.47,5.95-8.72,11.19-13.77,15.82s-11.12,8.8-18.15,9.77c-16.29,2.27-22.38-13.4-20.66-27a46,46,0,0,1,20.11-32.14c1.41-1,.2-3.33-1.25-2.38a51.88,51.88,0,0,0-21.32,28.92c-3.13,10.9-3.13,25.21,6.35,33.1,9.81,8.16,23.89,4.93,33.45-1.79,10.52-7.39,22.95-19.37,24.59-32.78C1937.23,343.31,1927.42,329,1912.47,329.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1869.54,337.94c-1-3.72-1.76-7.73-4.1-10.84-.78-1-2.25-.19-2.39.87-.44,3.43.7,6.9,1.48,10.23.37,1.59.94,3.35,1.44,5.13-3.12-5.07-7.43-11.09-13.7-12.13-6.43-1.07-12.44,2.75-17.27,6.54-11.35,8.88-18.56,21.77-28.75,31.8-6.13,6-15.59,11.8-22.45,3.33-4.84-6-5.51-15.59-4.79-23,1.38-14.21,9.08-27.21,20.3-35.89.82-.63-.17-2.06-1-1.49a50.1,50.1,0,0,0-21.64,32.67c-2.17,11.1-2.21,29.72,10.07,35.21,13.39,6,25.66-10.23,32.9-19.11,5.13-6.29,10.08-12.79,16.22-18.15,3.45-3,7.67-6.39,12.31-7.2,6.41-1.13,10.45,5.26,13.21,10.05,1.38,2.4,4.76,1.22,5.1-.86a18.68,18.68,0,0,1,.45,2.78c-4.87,1-10.6-1.95-15.06.88a.91.91,0,0,0,.15,1.65c4.94,1.61,13,3.64,18,1.82a2.69,2.69,0,0,0,2-2.35C1872.29,346.12,1870.48,341.59,1869.54,337.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.61,123.15a3.75,3.75,0,0,1-3.59-2.69c-.58-2-1.1-4-1.52-6.09a3.74,3.74,0,1,1,7.32-1.52c.38,1.84.85,3.7,1.38,5.51a3.75,3.75,0,0,1-2.54,4.64A3.81,3.81,0,0,1,257.61,123.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.69,98.49h-.18A3.73,3.73,0,0,1,251,94.57c0-.54.06-1.09.09-1.63a80.48,80.48,0,0,1,1.44-10.51,3.74,3.74,0,0,1,7.32,1.51,72.23,72.23,0,0,0-1.3,9.51l-.09,1.48A3.74,3.74,0,0,1,254.69,98.49ZM262.29,69a3.81,3.81,0,0,1-1.66-.39,3.73,3.73,0,0,1-1.69-5,77.58,77.58,0,0,1,6.26-10.52,3.73,3.73,0,1,1,6.1,4.31A71.48,71.48,0,0,0,265.64,67,3.74,3.74,0,0,1,262.29,69Zm18.73-24a3.74,3.74,0,0,1-2.42-6.59,80.41,80.41,0,0,1,9.92-7.17,3.74,3.74,0,0,1,3.89,6.39,72.21,72.21,0,0,0-9,6.48A3.72,3.72,0,0,1,281,45.07Zm26.7-14.55a3.74,3.74,0,0,1-1.09-7.32,78,78,0,0,1,12-2.61,3.73,3.73,0,1,1,1,7.4,71.39,71.39,0,0,0-10.81,2.37A3.72,3.72,0,0,1,307.72,30.52Zm41.74-.45a3.57,3.57,0,0,1-1-.14,72.26,72.26,0,0,0-10.87-2.12,3.74,3.74,0,0,1,.86-7.43,78.82,78.82,0,0,1,12,2.35,3.74,3.74,0,0,1-1,7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372,40.67a3.75,3.75,0,0,1-2.13-.67c-1.55-1.08-3.16-2.1-4.78-3a3.74,3.74,0,0,1,3.76-6.46c1.8,1.05,3.58,2.18,5.29,3.37A3.74,3.74,0,0,1,372,40.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.58,93.08a3.73,3.73,0,0,1-3.7-3.29c-.23-1.87-.53-3.76-.91-5.61a3.74,3.74,0,0,1,7.33-1.48c.41,2,.75,4.13,1,6.2A3.73,3.73,0,0,1,404,93.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.35,176.62a3.74,3.74,0,0,1-.29-7.46,71,71,0,0,0,10.75-1.7,3.74,3.74,0,0,1,1.73,7.28,79.3,79.3,0,0,1-11.89,1.87Zm-18.57-.83a4.46,4.46,0,0,1-.63,0,78.86,78.86,0,0,1-11.68-2.92,3.74,3.74,0,1,1,2.36-7.09,70.69,70.69,0,0,0,10.57,2.63,3.74,3.74,0,0,1-.62,7.43Zm47.31-7.48a3.74,3.74,0,0,1-1.75-7.05,70.68,70.68,0,0,0,9.23-5.79,3.74,3.74,0,0,1,4.44,6,79.1,79.1,0,0,1-10.19,6.39A3.72,3.72,0,0,1,364.09,168.31Zm23.17-18.91a3.74,3.74,0,0,1-2.89-6.11,72.42,72.42,0,0,0,6.23-8.93,3.74,3.74,0,1,1,6.44,3.79,78.2,78.2,0,0,1-6.89,9.87A3.71,3.71,0,0,1,387.26,149.4Zm13.92-26.49a3.71,3.71,0,0,1-3.59-4.77,72.41,72.41,0,0,0,2.21-10.67,3.74,3.74,0,1,1,7.41,1,78.44,78.44,0,0,1-2.44,11.78A3.73,3.73,0,0,1,401.18,122.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.81,164.92a3.8,3.8,0,0,1-2-.6c-1.74-1.13-3.47-2.35-5.12-3.62a3.73,3.73,0,1,1,4.54-5.93c1.5,1.14,3.06,2.25,4.65,3.27a3.74,3.74,0,0,1-2,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289,139.2a.9.9,0,0,0,1,.28l10.25-3.77A47.63,47.63,0,0,0,313.82,143l2.5,10.62a.89.89,0,0,0,.78.69l13,1.32a.9.9,0,0,0,.91-.52l4.58-9.91a47.73,47.73,0,0,0,14.76-4.43l9.28,5.74a.89.89,0,0,0,1-.06l10.15-8.29a.87.87,0,0,0,.27-1l-3.76-10.25a47.49,47.49,0,0,0,7.3-13.57l10.63-2.5a.89.89,0,0,0,.68-.78l1.32-13a.89.89,0,0,0-.51-.91l-9.91-4.58a47.39,47.39,0,0,0-4.44-14.76l5.75-9.28a.89.89,0,0,0-.07-1l-8.28-10.15a.89.89,0,0,0-1-.28l-10.25,3.77A47.76,47.76,0,0,0,345,52.51l-2.5-10.62a.91.91,0,0,0-.79-.69l-13-1.32a.9.9,0,0,0-.9.52l-4.58,9.91a47.56,47.56,0,0,0-14.76,4.43L299.16,49a.89.89,0,0,0-1,.06L288,57.35a.9.9,0,0,0-.27,1l3.77,10.25a47.76,47.76,0,0,0-7.31,13.57l-10.62,2.5a.91.91,0,0,0-.69.78l-1.32,13a.89.89,0,0,0,.52.91L282,104a47.66,47.66,0,0,0,4.44,14.76L280.64,128a.9.9,0,0,0,.07,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M329.38,113.89a16.12,16.12,0,0,1-2.32-32.07,16.12,16.12,0,1,1,4.7,31.89A15.89,15.89,0,0,1,329.38,113.89Zm0-23.27a6.19,6.19,0,0,0-1.05.08,7.14,7.14,0,0,0-3.22,12.8,7.07,7.07,0,0,0,5.3,1.33,7.14,7.14,0,0,0-1-14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M329.64,130.68c-1.11,0-2.23-.06-3.36-.17a35.17,35.17,0,0,1-5-.9h0l-.29-.08-.09,0-.22-.06-.06,0-.27-.08-.92-.28a1.51,1.51,0,0,1-1-1.42,1.51,1.51,0,0,1,2-1.42,31,31,0,0,0,6.28,1.31h0A30.16,30.16,0,0,0,359.4,102c.07-.46.12-.92.17-1.38a28.83,28.83,0,0,0,.16-3.07,30.12,30.12,0,0,0-60.08-3c-.1,1-.15,2-.15,3a30.08,30.08,0,0,0,2.84,12.76,1.41,1.41,0,0,1,.14.63,1.5,1.5,0,0,1-2.85.64,33,33,0,0,1-3.12-14,31.45,31.45,0,0,1,.17-3.35,33.1,33.1,0,0,1,66,3.3c0,1.11-.06,2.24-.17,3.37A33.16,33.16,0,0,1,329.64,130.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190,262.22A3.07,3.07,0,0,1,187,260c-.48-1.64-.9-3.32-1.25-5a3.07,3.07,0,0,1,6-1.25c.31,1.51.69,3,1.13,4.52a3.07,3.07,0,0,1-2.08,3.8A2.91,2.91,0,0,1,190,262.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.56,242h-.15a3.06,3.06,0,0,1-2.91-3.21c0-.44,0-.89.08-1.34a65.28,65.28,0,0,1,1.17-8.61,3.07,3.07,0,1,1,6,1.23,60.1,60.1,0,0,0-1.07,7.81c0,.4-.05.81-.07,1.21A3.07,3.07,0,0,1,187.56,242Zm6.23-24.16A3.08,3.08,0,0,1,191,213.4a64.82,64.82,0,0,1,5.14-8.63,3.07,3.07,0,1,1,5,3.54,58.06,58.06,0,0,0-4.65,7.81A3.06,3.06,0,0,1,193.79,217.83Zm15.37-19.67a3.06,3.06,0,0,1-2-5.4,64.38,64.38,0,0,1,8.13-5.88,3.07,3.07,0,1,1,3.2,5.24,58.16,58.16,0,0,0-7.37,5.32A3,3,0,0,1,209.16,198.16Zm21.9-11.93a3.07,3.07,0,0,1-.89-6,65.74,65.74,0,0,1,9.81-2.14,3.07,3.07,0,1,1,.84,6.08A57.28,57.28,0,0,0,232,186.1,3.48,3.48,0,0,1,231.06,186.23Zm34.24-.37a3.3,3.3,0,0,1-.82-.11,58.35,58.35,0,0,0-8.92-1.74,3.07,3.07,0,0,1,.71-6.1,65.71,65.71,0,0,1,9.85,1.93,3.07,3.07,0,0,1-.82,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.79,194.56A3.09,3.09,0,0,1,282,194c-1.27-.89-2.59-1.73-3.93-2.51a3.07,3.07,0,0,1,3.09-5.3c1.48.86,2.94,1.79,4.34,2.77a3.07,3.07,0,0,1-1.75,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M309.71,237.55a3.08,3.08,0,0,1-3-2.7c-.18-1.53-.43-3.08-.74-4.6a3.07,3.07,0,0,1,6-1.22c.34,1.68.62,3.39.82,5.09a3.05,3.05,0,0,1-2.67,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.73,306.08a3.06,3.06,0,0,1-.24-6.12,57,57,0,0,0,8.82-1.39,3.07,3.07,0,0,1,1.42,6,64,64,0,0,1-9.76,1.54Zm-15.24-.68a2.92,2.92,0,0,1-.51,0,65.58,65.58,0,0,1-9.59-2.39,3.07,3.07,0,1,1,1.94-5.82,58.76,58.76,0,0,0,8.67,2.16,3.07,3.07,0,0,1-.51,6.09Zm38.81-6.13a3.07,3.07,0,0,1-1.43-5.78,59.32,59.32,0,0,0,7.57-4.75,3.07,3.07,0,1,1,3.65,4.93,65.37,65.37,0,0,1-8.36,5.24A3.09,3.09,0,0,1,277.3,299.27Zm19-15.52a3.06,3.06,0,0,1-2.37-5,56.88,56.88,0,0,0,5.11-7.33,3.07,3.07,0,0,1,5.29,3.12,66.34,66.34,0,0,1-5.65,8.1A3.07,3.07,0,0,1,296.31,283.75ZM307.73,262a2.82,2.82,0,0,1-.85-.12,3.06,3.06,0,0,1-2.09-3.79,58.81,58.81,0,0,0,1.81-8.75,3.06,3.06,0,0,1,6.08.78,64.57,64.57,0,0,1-2,9.67A3.07,3.07,0,0,1,307.73,262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.55,296.48a3.06,3.06,0,0,1-1.66-.49c-1.44-.93-2.85-1.92-4.21-3a3.07,3.07,0,0,1,3.73-4.87c1.23.94,2.51,1.84,3.81,2.68a3.07,3.07,0,0,1-1.67,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.7,275.39a.73.73,0,0,0,.82.22l8.41-3.09a39.21,39.21,0,0,0,11.13,6l2.05,8.71a.76.76,0,0,0,.65.57l10.69,1.08a.74.74,0,0,0,.74-.42l3.76-8.13a39.36,39.36,0,0,0,12.11-3.64l7.61,4.71a.74.74,0,0,0,.86,0l8.32-6.8a.72.72,0,0,0,.23-.82L280,265.32a39,39,0,0,0,6-11.13l8.72-2.05a.74.74,0,0,0,.56-.64l1.08-10.7a.74.74,0,0,0-.42-.74l-8.13-3.75a38.82,38.82,0,0,0-3.64-12.11l4.72-7.62a.74.74,0,0,0-.06-.85L282,207.4a.74.74,0,0,0-.83-.22l-8.41,3.09a38.83,38.83,0,0,0-11.13-6l-2-8.71A.75.75,0,0,0,259,195l-10.69-1.08a.73.73,0,0,0-.74.42l-3.76,8.13a39.36,39.36,0,0,0-12.11,3.64L224,201.39a.72.72,0,0,0-.85.05l-8.33,6.8a.73.73,0,0,0-.22.82l3.09,8.41a39,39,0,0,0-6,11.13L203,230.65a.74.74,0,0,0-.56.64L201.37,242a.73.73,0,0,0,.43.74l8.12,3.75a39.1,39.1,0,0,0,3.65,12.11l-4.72,7.62a.72.72,0,0,0,.06.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M248.83,254.62a13.18,13.18,0,1,1,2-.14A14.47,14.47,0,0,1,248.83,254.62Zm0-19.09a5.07,5.07,0,0,0-.86.07,5.87,5.87,0,0,0-4.94,6.65,5.85,5.85,0,0,0,6.65,4.94,5.86,5.86,0,0,0-.85-11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M249,268.39a25.45,25.45,0,0,1-2.75-.14,26.9,26.9,0,0,1-4.12-.73h0l-.24-.06-.08,0-.17-.05-.06,0-.22-.06-.75-.23a1.23,1.23,0,0,1-.85-1.17,1.31,1.31,0,0,1,.06-.38,1.24,1.24,0,0,1,1.54-.79,24.45,24.45,0,0,0,5.15,1.08h0a24.72,24.72,0,0,0,26.93-20.95c.05-.37.1-.75.14-1.13a23.9,23.9,0,0,0,.13-2.52,24.7,24.7,0,0,0-49.28-2.46,23.26,23.26,0,0,0-.13,2.5,24.61,24.61,0,0,0,2.33,10.47,1.2,1.2,0,0,1,.12.52,1.23,1.23,0,0,1-2.34.52,27.08,27.08,0,0,1-2.56-11.51c0-.91,0-1.83.13-2.75a27.16,27.16,0,0,1,54.18,2.71c0,.91-.05,1.84-.14,2.76A27.19,27.19,0,0,1,249,268.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428.35,84.32a3.05,3.05,0,0,1-2.94-2.2c-.48-1.64-.9-3.32-1.25-5a3.06,3.06,0,0,1,6-1.25c.32,1.52.7,3,1.14,4.52a3.08,3.08,0,0,1-2.08,3.81A3.26,3.26,0,0,1,428.35,84.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M426,64.09h-.15a3.06,3.06,0,0,1-2.91-3.21c0-.45,0-.89.07-1.34a65.67,65.67,0,0,1,1.18-8.62,3.07,3.07,0,0,1,6,1.24,58.28,58.28,0,0,0-1.07,7.8c0,.41,0,.81-.07,1.22A3.06,3.06,0,0,1,426,64.09Zm6.23-24.16a3.14,3.14,0,0,1-1.36-.31,3.08,3.08,0,0,1-1.39-4.11,64.19,64.19,0,0,1,5.14-8.63,3.07,3.07,0,1,1,5,3.54,58,58,0,0,0-4.65,7.8A3,3,0,0,1,432.19,39.93Zm15.37-19.66a3.07,3.07,0,0,1-2-5.41A65.14,65.14,0,0,1,453.71,9a3.07,3.07,0,0,1,3.2,5.23,60.21,60.21,0,0,0-7.37,5.32A3.05,3.05,0,0,1,447.56,20.27Zm21.9-11.94a3.07,3.07,0,0,1-.89-6A63.33,63.33,0,0,1,478.38.19a3.06,3.06,0,1,1,.84,6.07,58.2,58.2,0,0,0-8.87,1.94A3.09,3.09,0,0,1,469.46,8.33ZM503.7,8a2.91,2.91,0,0,1-.82-.12A59.83,59.83,0,0,0,494,6.11a3.07,3.07,0,0,1,.7-6.09,64.34,64.34,0,0,1,9.86,1.92,3.07,3.07,0,0,1-.82,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M522.19,16.66a3,3,0,0,1-1.75-.55c-1.27-.88-2.59-1.72-3.93-2.5a3.07,3.07,0,0,1,3.09-5.3c1.48.86,2.94,1.79,4.34,2.77a3.06,3.06,0,0,1-1.75,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M548.1,59.66a3.07,3.07,0,0,1-3-2.7c-.18-1.54-.43-3.08-.74-4.6a3.07,3.07,0,1,1,6-1.22c.34,1.68.62,3.39.82,5.09a3.06,3.06,0,0,1-2.68,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M492.13,128.19a3.06,3.06,0,0,1-.24-6.12,59.52,59.52,0,0,0,8.82-1.39,3.07,3.07,0,0,1,1.42,6,65.42,65.42,0,0,1-9.76,1.53Zm-15.24-.68a4.73,4.73,0,0,1-.52,0,64.54,64.54,0,0,1-9.58-2.4,3.07,3.07,0,0,1,1.94-5.82,58.48,58.48,0,0,0,8.67,2.17,3.07,3.07,0,0,1-.51,6.09Zm38.81-6.14a3.07,3.07,0,0,1-1.43-5.78,58.22,58.22,0,0,0,7.57-4.75,3.07,3.07,0,0,1,3.65,4.94,65.37,65.37,0,0,1-8.36,5.24A3.08,3.08,0,0,1,515.7,121.37Zm19-15.51a3.07,3.07,0,0,1-2.37-5,59.69,59.69,0,0,0,5.11-7.33,3.07,3.07,0,1,1,5.29,3.11,64.83,64.83,0,0,1-5.65,8.1A3.08,3.08,0,0,1,534.71,105.86Zm11.42-21.73a3.17,3.17,0,0,1-.85-.12,3.06,3.06,0,0,1-2.09-3.8A58.68,58.68,0,0,0,545,71.47a3.06,3.06,0,0,1,6.08.78,64.44,64.44,0,0,1-2,9.66A3.07,3.07,0,0,1,546.13,84.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M454,118.59a3.06,3.06,0,0,1-1.66-.49c-1.44-.93-2.85-1.93-4.21-3a3.07,3.07,0,1,1,3.73-4.87c1.23.95,2.51,1.85,3.81,2.69a3.07,3.07,0,0,1-1.67,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M454.1,97.49a.72.72,0,0,0,.82.23l8.41-3.09a39.18,39.18,0,0,0,11.13,6l2.05,8.72a.75.75,0,0,0,.65.56L487.85,111a.71.71,0,0,0,.74-.42l3.76-8.13a38.68,38.68,0,0,0,12.1-3.64l7.62,4.72a.74.74,0,0,0,.85-.06l8.33-6.79a.75.75,0,0,0,.23-.82l-3.1-8.41a38.88,38.88,0,0,0,6-11.14l8.71-2.05a.73.73,0,0,0,.57-.64l1.08-10.69a.74.74,0,0,0-.42-.74l-8.13-3.76a38.82,38.82,0,0,0-3.64-12.11l4.72-7.61a.75.75,0,0,0-.06-.86l-6.79-8.32a.73.73,0,0,0-.83-.23l-8.41,3.09a39,39,0,0,0-11.13-6L498,17.66a.74.74,0,0,0-.64-.56L486.67,16a.75.75,0,0,0-.75.42l-3.75,8.13a38.82,38.82,0,0,0-12.11,3.64l-7.62-4.72a.74.74,0,0,0-.85.06l-8.33,6.79a.74.74,0,0,0-.22.83l3.09,8.41a39.07,39.07,0,0,0-6,11.13l-8.71,2a.72.72,0,0,0-.56.64l-1.09,10.69a.73.73,0,0,0,.43.74l8.12,3.76A39.36,39.36,0,0,0,452,80.7l-4.71,7.62a.74.74,0,0,0,.05.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M487.23,76.73a13.24,13.24,0,0,1-13.05-11.3,13.22,13.22,0,1,1,15,11.15A12.81,12.81,0,0,1,487.23,76.73Zm0-19.09a6.33,6.33,0,0,0-.86.06,5.89,5.89,0,1,0,.86-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M487.44,90.5c-.91,0-1.83,0-2.76-.14a27,27,0,0,1-4.11-.74h0l-.24-.07-.08,0-.17,0-.06,0-.22-.06c-.25-.08-.5-.15-.75-.24a1.21,1.21,0,0,1-.85-1.16,1.26,1.26,0,0,1,.06-.38,1.23,1.23,0,0,1,1.54-.79,25.1,25.1,0,0,0,5.15,1.08h0a24.74,24.74,0,0,0,26.93-21c.05-.38.1-.76.14-1.14.08-.84.13-1.68.13-2.51a24.71,24.71,0,0,0-49.29-2.47c-.08.84-.12,1.68-.12,2.51a24.57,24.57,0,0,0,2.33,10.46,1.4,1.4,0,0,1,.12.52,1.24,1.24,0,0,1-.71,1.12,1.23,1.23,0,0,1-1.63-.59,27.24,27.24,0,0,1-2.57-11.51c0-.92.05-1.84.14-2.75a27.16,27.16,0,0,1,54.18,2.71c0,.91-.05,1.83-.14,2.76A27.2,27.2,0,0,1,487.44,90.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M396.22,783.08a66.09,66.09,0,0,1-66-66.08V603.3a52.13,52.13,0,0,0-52.07-52.07H229.83a66.15,66.15,0,0,1-66.08-66.08v-63.9a66.15,66.15,0,0,1,66.08-66.07h290a7,7,0,0,1,0,14h-290a52.13,52.13,0,0,0-52.08,52.07v63.9a52.14,52.14,0,0,0,52.08,52.08h48.29a66.15,66.15,0,0,1,66.07,66.07V717a52.08,52.08,0,0,0,53.3,52.06l177.86-4.17a7,7,0,0,1,.33,14l-177.86,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1049,1269.18H289.78a65.8,65.8,0,0,1-64.34-51l-28.05-120.07a66.07,66.07,0,0,1,61.19-81l297.11-14.18a7,7,0,0,1,.66,14L259.25,1031A52.08,52.08,0,0,0,211,1094.88l28,120.07a51.86,51.86,0,0,0,50.71,40.23H1049a52.13,52.13,0,0,0,52.07-52.07v-90.28a7,7,0,0,1,14,0v90.28A66.15,66.15,0,0,1,1049,1269.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 493.1,
    cy: 317.32,
    r: 161.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 493.1,
    cy: 317.32,
    r: 156.38,
    transform: "translate(-79.95 441.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M349,310.66h-.05a1,1,0,0,1-.95-1,146.49,146.49,0,0,1,2.11-18.25,1,1,0,1,1,2,.35,142.66,142.66,0,0,0-2.08,18A1,1,0,0,1,349,310.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M364.16,253.36a1,1,0,0,1-.9-1.45,145.59,145.59,0,0,1,156.06-77.59,1,1,0,0,1-.35,2A144.22,144.22,0,0,0,493.1,174a142.74,142.74,0,0,0-128,78.85A1,1,0,0,1,364.16,253.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 496.51,
    cy: 320.72,
    r: 132.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M435.4,362.38,312.94,460.72a14,14,0,0,0-1.18,20.58l.93,1a13.05,13.05,0,0,0,18.52.28L443.44,371.25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 500.04,
    cy: 297.06,
    rx: 90.53,
    ry: 88.9,
    transform: "translate(-70.47 183.89) rotate(-19.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M467,203.81c-52.45,18.56-80.19,75.36-62,126.86s75.52,78.2,128,59.64S613.23,315,595,263.45,519.48,185.25,467,203.81Zm61.16,172.8c-44.74,15.84-93.62-6.94-109.17-50.88s8.12-92.39,52.86-108.22,93.62,6.94,109.17,50.87S572.94,360.78,528.19,376.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M416.16,339.53a.49.49,0,0,1-.45-.28c-1.06-2.09-2-4.27-2.95-6.46a.5.5,0,0,1,.92-.38c.89,2.17,1.87,4.32,2.92,6.39a.5.5,0,0,1-.22.68A.59.59,0,0,1,416.16,339.53Zm-8.58-26.31a.5.5,0,0,1-.5-.41A91.77,91.77,0,0,1,406,293.5c1.94-38,26.71-70.86,63.13-83.75a95.29,95.29,0,0,1,52.57-3.26.5.5,0,0,1-.22,1,94.22,94.22,0,0,0-52,3.22c-36,12.76-60.56,45.28-62.47,82.86a90.36,90.36,0,0,0,1.07,19.09.5.5,0,0,1-.41.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M324,482.1c-5.9,0-9.73-2.07-11.38-6.16a10.72,10.72,0,0,1,3.15-12.08l17.89-15.45a.51.51,0,0,1,.71.06.49.49,0,0,1-.05.7l-17.9,15.44a9.74,9.74,0,0,0-2.87,10.95c1.5,3.72,5,5.58,10.63,5.54a.47.47,0,0,1,.5.49.5.5,0,0,1-.5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M339.49,444.53a.45.45,0,0,1-.37-.17.49.49,0,0,1,.05-.7l2.32-2a.5.5,0,0,1,.65.76l-2.32,2A.5.5,0,0,1,339.49,444.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 500.04,
    cy: 600.54,
    r: 64.53,
    transform: "translate(-278.19 529.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.55,598.38h-.05a1,1,0,0,1-.95-1,60.52,60.52,0,0,1,.89-7.61,1,1,0,1,1,2,.35,60.29,60.29,0,0,0-.85,7.36A1,1,0,0,1,440.55,598.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M446.83,574.74a1,1,0,0,1-.45-.11,1,1,0,0,1-.44-1.34A60.3,60.3,0,0,1,500,540,61.34,61.34,0,0,1,511,541a1,1,0,1,1-.36,2,58.67,58.67,0,0,0-62.88,31.26A1,1,0,0,1,446.83,574.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 501.44,
    cy: 601.95,
    r: 54.61,
    transform: "matrix(0.23, -0.97, 0.97, 0.23, -199.61, 951.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.16,581.31c0,9.25-7.49,19.23-16.74,19.23s-16.75-10-16.75-19.23,7.5-15.81,16.75-15.81S518.16,572.06,518.16,581.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.64,636.14h40.87a9.89,9.89,0,0,0,9.43-6.88l2.2-6.87a9.89,9.89,0,0,0-6-12.3c-16.64-6.08-33.84-5.3-51.46.56a9.85,9.85,0,0,0-6.31,12l1.69,6.24A9.89,9.89,0,0,0,480.64,636.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 332.51,
    cy: 791.24,
    r: 161.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 332.51,
    cy: 791.24,
    r: 156.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M188.35,784.58h0a1,1,0,0,1-1-1.05,144.8,144.8,0,0,1,2.12-18.26,1,1,0,0,1,1.16-.81,1,1,0,0,1,.8,1.16,146.67,146.67,0,0,0-2.08,18A1,1,0,0,1,188.35,784.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.56,727.28a1,1,0,0,1-.45-.11,1,1,0,0,1-.44-1.34,145.59,145.59,0,0,1,156.06-77.59,1,1,0,0,1-.36,2,145,145,0,0,0-25.86-2.33,142.78,142.78,0,0,0-128.06,78.85A1,1,0,0,1,203.56,727.28Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 335.91,
    cy: 794.64,
    r: 132.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M193,688.47l166.57-61a18.38,18.38,0,0,1,23.23,10.07l100.75,237A13.55,13.55,0,0,1,476,892.46l-189.64,73.4a12.86,12.86,0,0,1-16.72-7.57l-89-243.06A20.87,20.87,0,0,1,193,688.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.71,960.38a14.55,14.55,0,0,1-13.65-9.5l-11.82-32.25a1,1,0,0,1,1.88-.69l11.81,32.25a12.54,12.54,0,0,0,15.88,7.49l21.46-7.55a1,1,0,0,1,.66,1.89l-21.46,7.55A14.39,14.39,0,0,1,286.71,960.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.52,909.3a1,1,0,0,1-.94-.66l-1.91-5.22a1,1,0,1,1,1.88-.69l1.91,5.22a1,1,0,0,1-.59,1.28A.87.87,0,0,1,258.52,909.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M192.83,686.33c23.88-5.25,105.59-24.36,168.45-53a5.6,5.6,0,0,1,7.48,2.89L470.5,874.06a6.45,6.45,0,0,1-3.36,8.45c-26.61,11.57-136.34,58.82-177.83,69.27a5.1,5.1,0,0,1-6-3.18L188.46,694.37A6.05,6.05,0,0,1,192.83,686.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M197.57,691.73c23-5.05,101.62-23.44,162.1-51a5.4,5.4,0,0,1,7.21,2.77l97.91,228.9a6.2,6.2,0,0,1-3.23,8.13C436,891.66,330.34,937.13,290.42,947.18a4.91,4.91,0,0,1-5.81-3L193.36,699.46A5.83,5.83,0,0,1,197.57,691.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M357.07,664.85c2.07-.75,3.46-2.12,3.1-3s-2.37-1.07-4.45-.35l-56.83,19.67c-2.08.72-3.06,2.19-2.17,3.27s3.31,1.34,5.37.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M302.3,690.47c-2.08.72-3.05,2.19-2.16,3.27s3.31,1.34,5.37.58l55-20.14c2.07-.75,3.46-2.12,3.09-3s-2.36-1.07-4.44-.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M305.77,699.94c-2.08.72-3,2.19-2.16,3.26s3.3,1.34,5.37.59l55-20.14c2.06-.76,3.46-2.12,3.09-3s-2.36-1.07-4.44-.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M377,701.05c2.07-.75,3.43-2.11,3-3s-2.42-1-4.49-.29L238,746.9c-2.07.74-2.59,2.06-1.15,2.93s4.3,1,6.37.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M241.38,756.23c-2.07.74-2.59,2.06-1.15,2.93s4.3,1,6.37.22l133.77-49c2.06-.75,3.43-2.11,3-3s-2.42-1-4.49-.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M281,794.45l-.06,0-18.58,7.29a5.42,5.42,0,0,1-6.85-2.2l-7.89-14.88a3.69,3.69,0,0,1-.23-2.9,4.44,4.44,0,0,1,2.29-2.57h0c1.52-.73,3.6-1.78,5.88-2.94,5-2.52,10.62-5.37,14-6.8l.08,0a5.62,5.62,0,0,1,6.63,1.58c2.4,3.18,5,10,7.76,17.24A5,5,0,0,1,281,794.45ZM250.4,780.68a2.79,2.79,0,0,0-1.45,1.61,2,2,0,0,0,.12,1.63L257,798.79a3.79,3.79,0,0,0,4.81,1.46L280.36,793l0,0a3.35,3.35,0,0,0,2.15-4.11C279.87,781.68,277.28,775,275,772a4,4,0,0,0-4.78-1c-3.36,1.41-9.22,4.37-13.92,6.75-2.3,1.16-4.38,2.22-5.91,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253,781.44c3.78-1.84,11.89-6.11,15.88-7.77a3.86,3.86,0,0,1,4.59,1c1.92,2.55,4.12,8.29,6.11,13.61a3.32,3.32,0,0,1-2.12,4.13l-14.85,5.83A3.69,3.69,0,0,1,258,796.8l-6.31-11.89A2.59,2.59,0,0,1,253,781.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293,770.94a2.86,2.86,0,0,0-1.35,4.62l1.39,1.85a5.46,5.46,0,0,0,6.1,1.71l88.84-35.84a3.79,3.79,0,0,0,2.25-4.92,4.11,4.11,0,0,0-5.22-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M254.79,783.55h0a3.06,3.06,0,0,1,4.35-.51l6.29,5.07a1,1,0,0,0,1.6-.73l.93-23.81a1.09,1.09,0,0,1,2.11-.35,42.94,42.94,0,0,1-.41,32.38s-6.28.08-14.53-7.76A3.22,3.22,0,0,1,254.79,783.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M297,834.13l-.05,0-18.58,7.29a5.42,5.42,0,0,1-6.85-2.2l-7.89-14.88a3.69,3.69,0,0,1-.23-2.9,4.44,4.44,0,0,1,2.29-2.57h0c1.52-.73,3.6-1.78,5.88-2.94,5-2.52,10.62-5.37,14-6.8l.08,0a5.6,5.6,0,0,1,6.62,1.58c2.41,3.18,5.05,10,7.77,17.24A5,5,0,0,1,297,834.13Zm-30.6-13.77A2.84,2.84,0,0,0,265,822a2,2,0,0,0,.13,1.63L273,838.47a3.79,3.79,0,0,0,4.81,1.46l18.59-7.29,0,0a3.35,3.35,0,0,0,2.14-4.11c-2.67-7.15-5.26-13.82-7.53-16.83a4.07,4.07,0,0,0-4.78-1c-3.36,1.41-9.22,4.37-13.92,6.75-2.3,1.17-4.38,2.22-5.91,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M269,821.12c3.78-1.84,11.89-6.11,15.88-7.77a3.84,3.84,0,0,1,4.58,1c1.93,2.55,4.13,8.29,6.12,13.61a3.32,3.32,0,0,1-2.12,4.13L278.64,838a3.69,3.69,0,0,1-4.66-1.47l-6.31-11.89A2.59,2.59,0,0,1,269,821.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M309,810.62a2.86,2.86,0,0,0-1.35,4.62l1.39,1.85a5.46,5.46,0,0,0,6.1,1.71L404,783a3.78,3.78,0,0,0,2.24-4.92,4.09,4.09,0,0,0-5.21-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M270.8,823.23h0a3.06,3.06,0,0,1,4.35-.51l6.29,5.07a1,1,0,0,0,1.6-.73l.93-23.81a1.09,1.09,0,0,1,2.1-.35,42.93,42.93,0,0,1-.4,32.38s-6.28.08-14.53-7.76A3.22,3.22,0,0,1,270.8,823.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M310.65,872.93l0,0L292,880.25a5.42,5.42,0,0,1-6.85-2.21l-7.89-14.88a3.69,3.69,0,0,1-.23-2.9,4.39,4.39,0,0,1,2.29-2.56h0c1.52-.74,3.59-1.79,5.87-3,4.74-2.39,10.63-5.37,14-6.8a5.71,5.71,0,0,1,6.7,1.55c2.41,3.19,5.05,10,7.77,17.24A5,5,0,0,1,310.65,872.93Zm-30.6-13.77a2.84,2.84,0,0,0-1.46,1.61,2,2,0,0,0,.13,1.63l7.89,14.88a3.8,3.8,0,0,0,4.81,1.45L310,871.44a3.43,3.43,0,0,0,2.18-4.13c-2.67-7.15-5.26-13.82-7.53-16.82a4.07,4.07,0,0,0-4.78-1c-3.36,1.4-9.22,4.37-13.93,6.75-2.29,1.16-4.38,2.21-5.9,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M282.67,859.92c3.78-1.84,11.89-6.11,15.88-7.77a3.85,3.85,0,0,1,4.58,1c1.93,2.55,4.13,8.29,6.12,13.61a3.32,3.32,0,0,1-2.12,4.13l-14.85,5.83a3.69,3.69,0,0,1-4.66-1.47l-6.31-11.88A2.6,2.6,0,0,1,282.67,859.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M322.61,849.43a2.85,2.85,0,0,0-1.35,4.61l1.39,1.86a5.47,5.47,0,0,0,6.1,1.7l88.84-35.84a3.77,3.77,0,0,0,2.24-4.92,4.09,4.09,0,0,0-5.21-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M284.44,862h0a3.06,3.06,0,0,1,4.35-.52l6.29,5.07a1,1,0,0,0,1.6-.72l.93-23.82a1.09,1.09,0,0,1,2.1-.35,42.93,42.93,0,0,1-.4,32.38s-6.28.08-14.53-7.76A3.21,3.21,0,0,1,284.44,862Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M324.4,913.08l0,0-18.58,7.29a5.42,5.42,0,0,1-6.85-2.21L291,903.3a3.63,3.63,0,0,1-.23-2.89,4.38,4.38,0,0,1,2.29-2.57h0c1.52-.74,3.6-1.79,5.88-3,5-2.51,10.62-5.37,14-6.8a5.67,5.67,0,0,1,6.7,1.56c2.41,3.18,5.05,10,7.77,17.23A5,5,0,0,1,324.4,913.08ZM293.8,899.3a2.84,2.84,0,0,0-1.46,1.61,2.09,2.09,0,0,0,.12,1.63l7.9,14.88a3.79,3.79,0,0,0,4.81,1.45l18.59-7.29,0,0a3.35,3.35,0,0,0,2.15-4.11c-2.67-7.15-5.26-13.81-7.54-16.82a4.09,4.09,0,0,0-4.77-1c-3.36,1.4-9.22,4.37-13.92,6.75-2.3,1.16-4.38,2.21-5.91,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M296.42,900.06c3.78-1.83,11.89-6.1,15.88-7.77a3.85,3.85,0,0,1,4.58,1c1.93,2.55,4.13,8.29,6.12,13.61a3.33,3.33,0,0,1-2.12,4.13L306,916.89a3.69,3.69,0,0,1-4.66-1.46l-6.31-11.89A2.6,2.6,0,0,1,296.42,900.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.36,889.57a2.85,2.85,0,0,0-1.35,4.61L336.4,896a5.49,5.49,0,0,0,6.1,1.71l88.84-35.85a3.77,3.77,0,0,0,2.24-4.92,4.1,4.1,0,0,0-5.21-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M298.19,902.18h0a3.06,3.06,0,0,1,4.35-.52l6.29,5.08a1,1,0,0,0,1.6-.73l.92-23.82a1.09,1.09,0,0,1,2.11-.34,42.93,42.93,0,0,1-.4,32.38s-6.28.08-14.53-7.76A3.22,3.22,0,0,1,298.19,902.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M274.59,621.26c-7.55-2-12.75,0-16,2.45a7.81,7.81,0,0,0-2.39,9.63l7.94,16.76,19.51-5.25S289.4,625.14,274.59,621.26Zm-3.19,17a5,5,0,1,1,3-6.44A5,5,0,0,1,271.4,638.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.16,642.66a1,1,0,0,1-.9-.58L261,639.42a1,1,0,0,1,.48-1.33,1,1,0,0,1,1.32.47l1.27,2.67a1,1,0,0,1-.48,1.33A1,1,0,0,1,263.16,642.66Zm-2.48-5.23a1,1,0,0,1-.9-.57l-1-2a8,8,0,0,1,2.43-9.81,15.63,15.63,0,0,1,7-2.91,1,1,0,0,1,1.14.84,1,1,0,0,1-.84,1.14,13.51,13.51,0,0,0-6.14,2.53,6,6,0,0,0-1.82,7.36l1,2a1,1,0,0,1-.47,1.33A1,1,0,0,1,260.68,637.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M242.42,670.75l-3.2-8.72a5.66,5.66,0,0,1,3.56-7.33l60.84-20a5.52,5.52,0,0,1,6.77,3L314,646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.13,653.29a1,1,0,0,1-.34-1.94l2.58-1a1,1,0,1,1,.69,1.88l-2.58.94A.87.87,0,0,1,258.13,653.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.5,667.36a1,1,0,0,1-.94-.65l-1.29-3.53a5.76,5.76,0,0,1,3.44-7.4l9.5-3.48a1,1,0,1,1,.68,1.87l-9.5,3.48a3.79,3.79,0,0,0-2.25,4.85l1.29,3.52a1,1,0,0,1-.59,1.28A1,1,0,0,1,244.5,667.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M222.42,674.46,327.5,636a8.28,8.28,0,0,1,10,3.64l.28.48a7.11,7.11,0,0,1-3.71,10.22L226.27,689.79a4.63,4.63,0,0,1-6-3l-1.53-4.91A6,6,0,0,1,222.42,674.46Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 447.46,
    cy: 1210.92,
    rx: 166.28,
    ry: 151.17,
    transform: "translate(-133.55 58.11) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 447.46,
    cy: 1210.92,
    rx: 160.75,
    ry: 146.15,
    transform: "translate(-133.56 58.11) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M299.41,1221.5a1,1,0,0,1-1-1,126.88,126.88,0,0,1,.24-17.22,1,1,0,0,1,2,.17,124.36,124.36,0,0,0-.23,16.94,1,1,0,0,1-.94,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M308.91,1166.53a1.08,1.08,0,0,1-.38-.08,1,1,0,0,1-.54-1.31c9.71-23.36,26.2-44,47.67-59.73a160.13,160.13,0,0,1,76.49-29.54,166.24,166.24,0,0,1,27-.84,1,1,0,0,1,.94,1,1,1,0,0,1-1.05,1,163.23,163.23,0,0,0-26.68.83c-55.63,6.31-102.59,40.05-122.54,88.05A1,1,0,0,1,308.91,1166.53Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 451.3,
    cy: 1213.69,
    rx: 136.06,
    ry: 123.7,
    transform: "translate(-133.84 58.56) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M323.28,1160.49l-17.93,87.18a28.94,28.94,0,0,0,21.52,33.89l206.88,50.81a20.88,20.88,0,0,0,24.39-12.44c8.47-21.07,22-59.17,26.09-97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M533.23,1326.61h0a20.85,20.85,0,0,1-3-.46.5.5,0,1,1,.22-1,19,19,0,0,0,2.89.44.5.5,0,0,1,.46.54A.49.49,0,0,1,533.23,1326.61Zm6.92-.7a.52.52,0,0,1-.48-.37.5.5,0,0,1,.35-.61,20.44,20.44,0,0,0,2.74-1,.5.5,0,0,1,.66.25.49.49,0,0,1-.25.66,21.15,21.15,0,0,1-2.88,1.06Zm-16.69-1.42h-.12l-2.91-.72a.5.5,0,0,1-.37-.6.51.51,0,0,1,.61-.37l2.91.72a.5.5,0,0,1-.12,1Zm-9.71-2.38-.12,0-2.91-.71a.51.51,0,0,1-.37-.61.51.51,0,0,1,.61-.36l2.91.71a.51.51,0,0,1,.37.61A.5.5,0,0,1,513.75,1322.11Zm35-1.18a.49.49,0,0,1-.35-.15.5.5,0,0,1,0-.71,19.15,19.15,0,0,0,1.92-2.2.5.5,0,0,1,.8.6,21.16,21.16,0,0,1-2,2.32A.54.54,0,0,1,548.7,1320.93ZM504,1319.72h-.12L501,1319a.5.5,0,0,1-.37-.6.51.51,0,0,1,.61-.37l2.91.72a.5.5,0,0,1-.12,1Zm-9.71-2.38-.12,0-2.91-.71a.5.5,0,1,1,.23-1l2.92.71a.5.5,0,0,1,.36.61A.49.49,0,0,1,494.33,1317.34Zm-9.71-2.39h-.12l-2.91-.72a.49.49,0,0,1-.37-.6.5.5,0,0,1,.6-.37l2.92.72a.5.5,0,0,1-.12,1Zm-9.71-2.38-.12,0-2.92-.71a.51.51,0,0,1-.36-.61.49.49,0,0,1,.6-.36l2.92.71a.51.51,0,0,1,.36.61A.49.49,0,0,1,474.91,1312.57Zm78.95-.11a.58.58,0,0,1-.19,0,.5.5,0,0,1-.28-.65c.36-.9.72-1.83,1.1-2.79a.5.5,0,0,1,.64-.29.5.5,0,0,1,.29.65c-.37,1-.74,1.9-1.1,2.8A.49.49,0,0,1,553.86,1312.46Zm-88.66-2.28h-.12l-2.92-.72a.48.48,0,0,1-.36-.6.5.5,0,0,1,.6-.37l2.91.72a.49.49,0,0,1,.37.6A.5.5,0,0,1,465.2,1310.18Zm-9.72-2.38-.12,0-2.91-.71a.51.51,0,0,1-.37-.61.5.5,0,0,1,.61-.36l2.91.71a.51.51,0,0,1,.37.61A.5.5,0,0,1,455.48,1307.8Zm-9.71-2.39h-.12l-2.91-.72a.5.5,0,0,1-.37-.6.51.51,0,0,1,.61-.37l2.91.72a.5.5,0,0,1,.37.6A.5.5,0,0,1,445.77,1305.41Zm111.67-2.29a.51.51,0,0,1-.17,0,.5.5,0,0,1-.3-.64c.35-.92.69-1.86,1-2.81a.49.49,0,0,1,.64-.3.5.5,0,0,1,.3.64c-.35,1-.7,1.9-1,2.82A.49.49,0,0,1,557.44,1303.12ZM436.06,1303l-.12,0-2.91-.71a.51.51,0,0,1-.37-.61.5.5,0,0,1,.61-.36l2.91.71a.5.5,0,0,1-.12,1Zm-9.71-2.39h-.12l-2.91-.72a.49.49,0,0,1-.37-.6.51.51,0,0,1,.6-.37l2.92.72a.48.48,0,0,1,.36.6A.49.49,0,0,1,426.35,1300.64Zm-9.71-2.38-.12,0-2.91-.71a.5.5,0,0,1-.37-.61.49.49,0,0,1,.6-.36l2.92.71a.5.5,0,0,1-.12,1Zm-9.71-2.39h-.12l-2.92-.72a.49.49,0,0,1-.36-.6.5.5,0,0,1,.6-.37l2.92.72a.5.5,0,0,1-.12,1Zm153.89-2.16a.45.45,0,0,1-.16,0,.5.5,0,0,1-.31-.64c.32-.93.65-1.87,1-2.83a.51.51,0,0,1,.63-.32.5.5,0,0,1,.32.64c-.33,1-.65,1.91-1,2.84A.49.49,0,0,1,560.82,1293.71Zm-163.6-.22-.12,0-2.92-.71a.5.5,0,0,1-.36-.61.49.49,0,0,1,.6-.36l2.91.71a.5.5,0,0,1,.37.61A.51.51,0,0,1,397.22,1293.49Zm-9.72-2.39h-.12l-2.91-.72a.49.49,0,0,1-.36-.6.5.5,0,0,1,.6-.37l2.91.72a.49.49,0,0,1,.37.6A.5.5,0,0,1,387.5,1291.1Zm-9.71-2.38-.12,0-2.91-.71a.5.5,0,1,1,.24-1l2.91.72a.5.5,0,0,1-.12,1Zm-9.71-2.39H368l-2.91-.72a.5.5,0,1,1,.24-1l2.91.72a.5.5,0,0,1,.37.6A.5.5,0,0,1,368.08,1286.33ZM564,1284.22l-.15,0a.49.49,0,0,1-.33-.62c.31-1,.61-1.9.91-2.86a.5.5,0,0,1,.63-.33.49.49,0,0,1,.32.63c-.3,1-.6,1.92-.9,2.86A.51.51,0,0,1,564,1284.22ZM358.37,1284l-.12,0-2.91-.71a.5.5,0,0,1-.37-.61.51.51,0,0,1,.61-.37l2.91.72a.51.51,0,0,1,.37.6A.52.52,0,0,1,358.37,1284Zm-9.71-2.39h-.12l-2.91-.72a.5.5,0,1,1,.23-1l2.92.71a.5.5,0,0,1,.36.61A.49.49,0,0,1,348.66,1281.56Zm-9.71-2.39h-.12l-2.92-.72a.49.49,0,0,1-.36-.6.5.5,0,0,1,.6-.37l2.92.72a.5.5,0,0,1,.36.6A.49.49,0,0,1,339,1279.17Zm-9.63-2.64a.58.58,0,0,1-.19,0,29,29,0,0,1-2.77-1.29.49.49,0,0,1-.2-.67.49.49,0,0,1,.67-.21,26.88,26.88,0,0,0,2.67,1.24.5.5,0,0,1-.18,1Zm237.61-1.87-.14,0a.51.51,0,0,1-.34-.62l.84-2.88a.5.5,0,0,1,1,.27l-.84,2.89A.49.49,0,0,1,566.93,1274.66Zm-246-3.44a.47.47,0,0,1-.34-.13,27.52,27.52,0,0,1-2.13-2.19.5.5,0,0,1,.75-.66,29.22,29.22,0,0,0,2.05,2.11.5.5,0,0,1,0,.71A.46.46,0,0,1,320.91,1271.22ZM569.64,1265l-.13,0a.5.5,0,0,1-.36-.61c.26-1,.51-1.93.76-2.9a.5.5,0,0,1,1,.25c-.25,1-.5,1.94-.76,2.91A.5.5,0,0,1,569.64,1265Zm-254.72-1.75a.5.5,0,0,1-.45-.28,26.85,26.85,0,0,1-1.21-2.8.5.5,0,1,1,.93-.34,26.74,26.74,0,0,0,1.18,2.69.52.52,0,0,1-.22.68A.64.64,0,0,1,314.92,1263.28Zm257.16-8-.12,0a.5.5,0,0,1-.37-.6c.23-1,.46-1.94.68-2.92a.5.5,0,0,1,1,.22c-.22,1-.45,2-.68,2.93A.5.5,0,0,1,572.08,1255.33Zm-259.94-1.6a.51.51,0,0,1-.5-.45c-.09-.91-.13-1.85-.13-2.77v-.28a.49.49,0,0,1,.5-.49h0a.5.5,0,0,1,.5.5v.27a26.37,26.37,0,0,0,.13,2.67.5.5,0,0,1-.45.55Zm262.09-8.17h-.1a.5.5,0,0,1-.39-.59c.2-1,.39-2,.58-2.93a.5.5,0,0,1,.59-.4.49.49,0,0,1,.39.59c-.19,1-.38,2-.58,2.94A.5.5,0,0,1,574.23,1245.56Zm-261.32-1.75h-.1a.51.51,0,0,1-.39-.59l.61-2.94a.5.5,0,0,1,.59-.39.51.51,0,0,1,.39.59l-.61,2.94A.49.49,0,0,1,312.91,1243.81Zm263.15-8.08H576a.5.5,0,0,1-.41-.57c.17-1,.33-2,.48-3a.51.51,0,0,1,.57-.42.51.51,0,0,1,.42.57c-.16,1-.32,2-.48,3A.49.49,0,0,1,576.06,1235.73ZM314.93,1234h-.1a.49.49,0,0,1-.39-.59l.6-2.94a.5.5,0,0,1,1,.21l-.6,2.93A.5.5,0,0,1,314.93,1234Zm262.58-8.17h-.06a.49.49,0,0,1-.43-.56l.36-3a.5.5,0,0,1,.55-.44.5.5,0,0,1,.44.55c-.11,1-.23,2-.36,3A.51.51,0,0,1,577.51,1225.84Zm-260.57-1.62h-.1a.51.51,0,0,1-.39-.59l.61-2.94a.49.49,0,0,1,.59-.39.51.51,0,0,1,.39.59l-.61,2.94A.49.49,0,0,1,316.94,1224.22Zm255.11-3.68-.12,0-2.92-.7a.5.5,0,0,1-.37-.6.51.51,0,0,1,.6-.37l2.92.7a.49.49,0,0,1,.37.6A.5.5,0,0,1,572.05,1220.54Zm-9.73-2.33h-.12l-2.91-.7a.5.5,0,0,1,.23-1l2.92.7a.52.52,0,0,1,.37.61A.51.51,0,0,1,562.32,1218.21Zm-9.72-2.33h-.12l-2.92-.7a.51.51,0,0,1-.37-.6.5.5,0,0,1,.6-.37l2.92.69a.5.5,0,0,1,.37.61A.49.49,0,0,1,552.6,1215.88ZM319,1214.42h-.1a.49.49,0,0,1-.39-.59l.6-2.94a.5.5,0,0,1,1,.21l-.6,2.93A.5.5,0,0,1,319,1214.42Zm223.91-.87h-.12l-2.91-.7a.49.49,0,0,1-.37-.6.5.5,0,0,1,.6-.37l2.92.7a.5.5,0,0,1-.12,1Zm-9.73-2.32-.11,0-2.92-.7a.5.5,0,1,1,.23-1l2.92.7a.49.49,0,0,1,.37.6A.5.5,0,0,1,533.14,1211.23Zm-9.72-2.33-.12,0-2.92-.7a.5.5,0,0,1-.37-.6.51.51,0,0,1,.61-.37l2.92.7a.5.5,0,0,1,.37.6A.51.51,0,0,1,523.42,1208.9Zm-9.73-2.33h-.11l-2.92-.7a.5.5,0,0,1,.23-1l2.92.7a.5.5,0,0,1-.12,1ZM321,1204.63h-.1a.51.51,0,0,1-.39-.59l.61-2.94a.49.49,0,0,1,.59-.39.51.51,0,0,1,.39.59l-.61,2.94A.5.5,0,0,1,321,1204.63Zm183-.39h-.12l-2.92-.7a.51.51,0,0,1-.37-.6.5.5,0,0,1,.61-.37l2.91.69a.5.5,0,0,1,.37.61A.48.48,0,0,1,504,1204.24Zm-9.73-2.33h-.11l-2.92-.7a.5.5,0,1,1,.23-1l2.92.7a.5.5,0,0,1,.37.6A.5.5,0,0,1,494.24,1201.91Zm-9.72-2.32-.12,0-2.92-.7a.5.5,0,0,1-.37-.6.51.51,0,0,1,.61-.37l2.91.7a.49.49,0,0,1,.37.6A.5.5,0,0,1,484.52,1199.59Zm-9.73-2.33-.11,0-2.92-.69a.5.5,0,0,1-.37-.61.5.5,0,0,1,.6-.37l2.92.7a.5.5,0,0,1-.12,1Zm-9.72-2.33H465l-2.92-.7a.5.5,0,1,1,.24-1l2.91.7a.5.5,0,0,1-.11,1Zm-142.08-.1h-.11a.49.49,0,0,1-.38-.59l.6-2.94a.5.5,0,1,1,1,.21l-.6,2.93A.5.5,0,0,1,323,1194.83Zm132.35-2.23h-.11l-2.92-.7a.5.5,0,0,1-.37-.6.49.49,0,0,1,.6-.37l2.92.69a.51.51,0,0,1,.37.61A.5.5,0,0,1,455.34,1192.6Zm-9.72-2.33h-.12l-2.92-.7a.5.5,0,0,1-.37-.6.51.51,0,0,1,.61-.37l2.91.7a.5.5,0,0,1-.11,1Zm-9.73-2.32-.11,0-2.92-.7a.49.49,0,0,1-.37-.6.5.5,0,0,1,.6-.37l2.92.7a.5.5,0,0,1,.37.6A.51.51,0,0,1,435.89,1188Zm-9.72-2.33-.12,0-2.92-.69a.51.51,0,0,1-.37-.61.51.51,0,0,1,.6-.37l2.92.7a.5.5,0,0,1-.11,1ZM325,1185h-.1a.5.5,0,0,1-.39-.59l.6-2.94a.5.5,0,0,1,.59-.39.49.49,0,0,1,.39.59l-.6,2.94A.5.5,0,0,1,325,1185Zm91.44-1.75h-.12l-2.91-.7a.5.5,0,0,1,.23-1l2.92.7a.5.5,0,0,1-.12,1Zm-9.72-2.33h-.12l-2.92-.7a.5.5,0,1,1,.23-1l2.92.7a.5.5,0,0,1-.11,1Zm-9.73-2.33h-.12l-2.91-.7a.5.5,0,1,1,.23-1l2.92.7a.5.5,0,0,1,.37.6A.5.5,0,0,1,397,1178.63Zm-9.72-2.32-.12,0-2.92-.7a.5.5,0,0,1-.37-.6.51.51,0,0,1,.6-.37l2.92.7a.49.49,0,0,1,.37.6A.5.5,0,0,1,387.27,1176.31ZM327,1175.24h-.1a.5.5,0,0,1-.39-.59l.61-2.94a.5.5,0,0,1,.59-.39.51.51,0,0,1,.39.6l-.61,2.93A.49.49,0,0,1,327,1175.24Zm50.53-1.26-.12,0-2.91-.69a.5.5,0,0,1-.37-.61.5.5,0,0,1,.6-.37l2.92.7a.5.5,0,0,1-.12,1Zm-9.72-2.33h-.12l-2.92-.7a.5.5,0,0,1,.23-1l2.92.7a.5.5,0,0,1,.37.61A.49.49,0,0,1,367.82,1171.65Zm-9.73-2.33H358l-2.91-.7a.5.5,0,0,1,.23-1l2.92.7a.5.5,0,0,1-.12,1Zm-9.73-2.33h-.11l-2.92-.7a.5.5,0,0,1-.37-.6.51.51,0,0,1,.6-.37l2.92.7a.5.5,0,0,1-.12,1ZM329,1165.45h-.1a.5.5,0,0,1-.39-.59l.6-2.94a.5.5,0,0,1,1,.2l-.6,2.94A.5.5,0,0,1,329,1165.45Zm9.61-.78-.12,0-2.91-.7a.49.49,0,0,1-.37-.6.5.5,0,0,1,.6-.37l2.92.7a.5.5,0,0,1,.37.6A.51.51,0,0,1,338.64,1164.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M399,1112.22l2.22-6.53a5.26,5.26,0,0,1,4.6-2.06c6.7.52,23.14,2.54,29.47,10.15l-.7,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M420.72,1110.62a9.5,9.5,0,0,1-4.46-1.07,4.15,4.15,0,0,1-2.14-4.65l5-20.89,10.63,2.55-5,20.87A4.15,4.15,0,0,1,420.72,1110.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M502,1136.87l2.22-6.52a5.25,5.25,0,0,1,4.6-2.07c6.71.52,23.14,2.54,29.47,10.15l-.7,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M523.71,1135.27a9.51,9.51,0,0,1-4.47-1.07,4.14,4.14,0,0,1-2.14-4.64l5.53-23.1,10.63,2.55-5.53,23.08A4.15,4.15,0,0,1,523.71,1135.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M416.81,1088.87l115.25,23.59a5.66,5.66,0,0,0,6.35-3.26,48.14,48.14,0,0,0,3.83-14.41,13.56,13.56,0,0,0-10.12-14.22c-21.21-5.62-75.51-18.6-108.27-13.93a10.77,10.77,0,0,0-8.06,5.74,26.26,26.26,0,0,0-3.05,11.55A5,5,0,0,0,416.81,1088.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M416.38,1083h-.14a1,1,0,0,1-.86-1.13,28.48,28.48,0,0,1,2.81-8.62,10.27,10.27,0,0,1,8.47-5.29c6.84-.35,19.82-.61,29.88,1.5a1,1,0,0,1,.78,1.18,1,1,0,0,1-1.19.78c-9.84-2.07-22.63-1.81-29.37-1.47a8.31,8.31,0,0,0-6.82,4.26,26.42,26.42,0,0,0-2.57,7.93A1,1,0,0,1,416.38,1083Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M346.6,1096.92c37,8.37,197.26,44.94,242.33,61.65a9.72,9.72,0,0,1,6.38,9.27c-.23,13.06-1.61,43.18-9.1,71.58a8.51,8.51,0,0,1-8.66,6.27l-110.76-5.32-37.64-9-107.53-49.47a9.07,9.07,0,0,1-5.15-9.9c2.7-14.54,9.62-48.52,18.7-69.29A10,10,0,0,1,346.6,1096.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M573.43,1236.59h0l-3-.14a.51.51,0,0,1-.48-.53.52.52,0,0,1,.52-.47l3,.14a.5.5,0,0,1,0,1Zm-10-.48h0l-3-.14a.51.51,0,0,1-.48-.53.52.52,0,0,1,.53-.47l3,.14a.51.51,0,0,1,.48.53A.5.5,0,0,1,563.44,1236.11Zm-10-.48h0l-3-.14a.5.5,0,0,1-.48-.52.52.52,0,0,1,.53-.48l3,.14a.51.51,0,0,1,.48.53A.5.5,0,0,1,553.45,1235.63Zm-10-.48h0l-3-.14a.49.49,0,0,1-.47-.52.51.51,0,0,1,.52-.48l3,.14a.51.51,0,0,1,.47.53A.5.5,0,0,1,543.46,1235.15Zm-10-.48h0l-3-.14a.49.49,0,0,1-.47-.52.5.5,0,0,1,.52-.48l3,.14a.5.5,0,0,1,.47.53A.49.49,0,0,1,533.47,1234.67Zm-10-.48h0l-3-.14a.5.5,0,0,1-.47-.52.52.52,0,0,1,.52-.48l3,.14a.5.5,0,0,1,.47.53A.49.49,0,0,1,523.49,1234.19Zm54.6-.41H578a.5.5,0,0,1-.37-.61l.69-2.91a.5.5,0,0,1,.59-.38.5.5,0,0,1,.38.6c-.22,1-.45,2-.69,2.93A.49.49,0,0,1,578.09,1233.78Zm-64.59-.07h0l-3-.14a.5.5,0,0,1-.48-.52.52.52,0,0,1,.52-.48l3,.15a.5.5,0,0,1,.48.52A.5.5,0,0,1,513.5,1233.71Zm-10-.47h0l-3-.14a.5.5,0,0,1-.48-.52.52.52,0,0,1,.53-.48l3,.15a.5.5,0,0,1,.48.52A.51.51,0,0,1,503.51,1233.24Zm-10-.48h0l-3-.15a.5.5,0,0,1-.48-.52.52.52,0,0,1,.53-.48l3,.15a.5.5,0,0,1,0,1Zm-10-.48h0l-3-.15a.5.5,0,0,1-.48-.52.52.52,0,0,1,.53-.48l3,.15a.5.5,0,0,1,0,1Zm-10-.48h0l-3-.15a.49.49,0,0,1-.47-.52.5.5,0,0,1,.52-.48l3,.15a.49.49,0,0,1,.47.52A.5.5,0,0,1,473.54,1231.8Zm-9.86-1.33h-.12l-2.92-.7a.5.5,0,0,1-.37-.6.49.49,0,0,1,.6-.37l2.92.7a.5.5,0,0,1-.11,1Zm-9.73-2.33h-.12l-2.91-.7a.49.49,0,0,1-.37-.6.5.5,0,0,1,.6-.37l2.92.7a.5.5,0,0,1-.12,1Zm-9.73-2.32-.11,0-2.92-.7a.5.5,0,1,1,.23-1l2.92.7a.5.5,0,0,1,.37.6A.51.51,0,0,1,444.22,1225.82Zm136-1.81h-.1a.49.49,0,0,1-.39-.59c.19-1,.37-2,.55-2.93a.5.5,0,0,1,1,.18c-.18,1-.37,2-.56,2.95A.5.5,0,0,1,580.23,1224Zm-145.73-.52-.12,0-2.26-.54-2.82-1.28a.5.5,0,0,1-.24-.67.49.49,0,0,1,.66-.24l2.73,1.25,2.16.51a.5.5,0,0,1-.11,1Zm-11.35-4.72a.54.54,0,0,1-.21,0l-2.72-1.25a.51.51,0,0,1-.25-.67.5.5,0,0,1,.67-.24l2.72,1.25a.5.5,0,0,1-.21,1Zm-9.08-4.18a.54.54,0,0,1-.21,0l-2.73-1.25a.5.5,0,0,1-.24-.67.49.49,0,0,1,.66-.24l2.73,1.25a.5.5,0,0,1,.24.67A.49.49,0,0,1,414.07,1214.59Zm167.9-.42h-.08a.51.51,0,0,1-.42-.57c.16-1,.31-2,.45-3a.49.49,0,0,1,.57-.42.5.5,0,0,1,.42.56q-.21,1.49-.45,3A.5.5,0,0,1,582,1214.17Zm-177-3.76a.54.54,0,0,1-.21-.05l-2.72-1.25a.51.51,0,0,1-.25-.66.5.5,0,0,1,.67-.25l2.72,1.25a.5.5,0,0,1-.21,1Zm-9.08-4.18a.54.54,0,0,1-.21,0l-2.73-1.25a.49.49,0,0,1-.24-.66.5.5,0,0,1,.66-.25l2.73,1.25a.5.5,0,0,1,.24.67A.49.49,0,0,1,395.9,1206.23Zm187.46-2h-.06a.51.51,0,0,1-.44-.56c.13-1,.24-2,.36-3a.5.5,0,1,1,1,.12c-.11,1-.23,2-.36,3A.49.49,0,0,1,583.36,1204.26Zm-196.55-2.21a.54.54,0,0,1-.21,0l-2.72-1.25a.51.51,0,0,1-.25-.66.51.51,0,0,1,.67-.25l2.72,1.26a.5.5,0,0,1,.25.66A.52.52,0,0,1,386.81,1202.05Zm-9.08-4.18a.41.41,0,0,1-.21,0l-2.73-1.25a.49.49,0,0,1-.24-.66.5.5,0,0,1,.66-.25l2.73,1.26a.5.5,0,0,1-.21.95Zm206.71-3.56h-.05a.5.5,0,0,1-.45-.54c.1-1,.19-2,.27-3a.49.49,0,0,1,.54-.45.5.5,0,0,1,.46.54c-.09,1-.18,2-.27,3A.5.5,0,0,1,584.44,1194.31Zm-215.8-.62a.41.41,0,0,1-.21,0l-2.72-1.25a.5.5,0,0,1-.25-.66.51.51,0,0,1,.67-.25l2.72,1.26a.5.5,0,0,1,.25.66A.52.52,0,0,1,368.64,1193.69Zm-9.08-4.18a.52.52,0,0,1-.21,0l-2.73-1.26a.49.49,0,0,1-.24-.66.5.5,0,0,1,.66-.25l2.73,1.26a.5.5,0,0,1-.21,1Zm-9.09-4.18a.45.45,0,0,1-.2,0l-2.73-1.26a.5.5,0,0,1-.25-.66.52.52,0,0,1,.67-.25l2.72,1.26a.5.5,0,0,1,.25.66A.52.52,0,0,1,350.47,1185.33Zm234.76-1h0a.52.52,0,0,1-.47-.53c.07-1,.13-2,.19-3a.5.5,0,0,1,.53-.48.52.52,0,0,1,.47.53c-.06,1-.12,2-.19,3A.49.49,0,0,1,585.23,1184.34Zm-243.84-3.19a.52.52,0,0,1-.21,0l-2.73-1.26a.49.49,0,0,1-.24-.66.5.5,0,0,1,.66-.25l2.73,1.26a.5.5,0,0,1-.21,1ZM332.3,1177a.45.45,0,0,1-.2,0l-2.73-1.26a.5.5,0,0,1,.42-.9l2.72,1.25a.5.5,0,0,1-.21,1Zm253.45-2.62h0a.5.5,0,0,1-.48-.52c0-1.07.07-2.07.1-3a.5.5,0,0,1,1,0c0,.93-.06,1.94-.1,3A.5.5,0,0,1,585.75,1174.35Zm-259.49-3.13h-.09a.5.5,0,0,1-.4-.58l.57-3a.51.51,0,0,1,.59-.4.49.49,0,0,1,.39.59l-.57,3A.49.49,0,0,1,326.26,1171.22Zm256.19-4.5a.45.45,0,0,1-.16,0l-2.84-1a.5.5,0,0,1-.31-.63.5.5,0,0,1,.63-.32l2.85,1a.5.5,0,0,1-.17,1Zm-9.49-3.14a.39.39,0,0,1-.15,0l-2.86-.89a.5.5,0,0,1-.34-.63.51.51,0,0,1,.63-.33l2.87.9a.49.49,0,0,1,.32.62A.48.48,0,0,1,573,1163.58Zm-244.73-2.18h-.11a.49.49,0,0,1-.38-.59c.2-1,.4-1.94.62-2.94a.49.49,0,0,1,.59-.38.5.5,0,0,1,.39.59c-.22,1-.42,2-.62,2.94A.5.5,0,0,1,328.23,1161.4Zm235.16-.74a.34.34,0,0,1-.14,0l-2.88-.84a.51.51,0,0,1-.34-.62.5.5,0,0,1,.62-.34l2.88.85a.49.49,0,0,1,.34.62A.5.5,0,0,1,563.39,1160.66Zm-9.6-2.78-.14,0-2.89-.82a.5.5,0,1,1,.28-1l2.88.82a.5.5,0,0,1-.13,1Zm-9.63-2.7-.14,0-2.89-.79a.5.5,0,1,1,.27-1l2.89.8a.5.5,0,0,1-.13,1Zm-9.65-2.63a.27.27,0,0,1-.13,0l-2.9-.77a.5.5,0,0,1,.26-1l2.9.78a.5.5,0,0,1-.13,1Zm-204.15-.93h-.11a.5.5,0,0,1-.38-.6c.22-1,.45-1.94.68-2.92a.5.5,0,0,1,.6-.38.5.5,0,0,1,.37.6c-.23,1-.45,2-.67,2.93A.5.5,0,0,1,330.36,1151.62ZM524.84,1150l-.12,0-2.9-.76a.5.5,0,0,1,.25-1l2.9.76a.5.5,0,0,1-.13,1Zm-9.67-2.53-.13,0-2.9-.75a.5.5,0,0,1,.25-1l2.9.75a.5.5,0,0,1-.12,1Zm-9.69-2.5h-.12l-2.91-.75a.5.5,0,0,1-.36-.6.51.51,0,0,1,.61-.37l2.91.75a.49.49,0,0,1,.36.6A.5.5,0,0,1,505.48,1145Zm-9.69-2.46-.12,0-2.91-.73a.5.5,0,0,1-.36-.61.49.49,0,0,1,.6-.36l2.91.73a.51.51,0,0,1,.37.61A.5.5,0,0,1,495.79,1142.49Zm-163.11-.6-.12,0a.5.5,0,0,1-.37-.6c.24-1,.49-1.94.74-2.92a.51.51,0,0,1,.61-.36.5.5,0,0,1,.36.61c-.25,1-.5,1.94-.74,2.91A.49.49,0,0,1,332.68,1141.89Zm153.41-1.84H486l-2.91-.73a.5.5,0,0,1,.24-1l2.91.73a.5.5,0,0,1-.12,1Zm-9.7-2.41h-.12l-2.92-.72a.51.51,0,0,1-.36-.61.5.5,0,0,1,.6-.36l2.92.72a.48.48,0,0,1,.36.6A.49.49,0,0,1,476.39,1137.64Zm-9.71-2.39h-.12l-2.92-.71a.5.5,0,0,1,.24-1l2.92.72a.5.5,0,0,1-.12,1Zm-9.72-2.37h-.12l-2.91-.71a.5.5,0,1,1,.23-1l2.92.71a.5.5,0,0,1,.37.6A.5.5,0,0,1,457,1132.88Zm-121.74-.67-.13,0a.5.5,0,0,1-.35-.62l.81-2.9a.5.5,0,0,1,1,.28c-.28,1-.55,1.92-.82,2.89A.5.5,0,0,1,335.22,1132.21Zm112-1.68h-.12l-2.91-.7a.5.5,0,0,1-.37-.61.5.5,0,0,1,.6-.37l2.92.71a.5.5,0,0,1,.37.6A.5.5,0,0,1,447.24,1130.53Zm-9.72-2.33-.12,0-2.92-.69a.5.5,0,0,1,.24-1l2.91.7a.49.49,0,0,1,.37.6A.5.5,0,0,1,437.52,1128.2Zm-9.73-2.32-.12,0-2.92-.69a.5.5,0,1,1,.23-1l2.92.69a.49.49,0,0,1,.37.6A.5.5,0,0,1,427.79,1125.88Zm-9.74-2.31h-.11l-2.92-.69a.5.5,0,0,1,.23-1l2.92.69a.5.5,0,0,1-.12,1Zm-80-1a.39.39,0,0,1-.15,0,.51.51,0,0,1-.33-.63c.31-1,.62-1.92.93-2.86a.49.49,0,0,1,.63-.32.51.51,0,0,1,.32.63c-.31.94-.62,1.89-.92,2.85A.5.5,0,0,1,338.05,1122.6Zm70.27-1.32-.12,0-2.92-.68a.5.5,0,0,1,.23-1l2.92.68a.49.49,0,0,1,.37.6A.5.5,0,0,1,408.32,1121.28Zm-9.74-2.28-.12,0-2.92-.68a.49.49,0,0,1-.37-.6.5.5,0,0,1,.6-.37l2.92.68a.49.49,0,0,1,.37.6A.5.5,0,0,1,398.58,1119Zm-9.75-2.27h-.11l-2.92-.68a.5.5,0,1,1,.22-1l2.93.68a.5.5,0,0,1,.37.6A.5.5,0,0,1,388.83,1116.73Zm-9.74-2.26H379l-2.92-.67a.5.5,0,0,1,.23-1l2.92.68a.49.49,0,0,1,.37.6A.48.48,0,0,1,379.09,1114.47Zm-37.8-1.34-.18,0a.49.49,0,0,1-.29-.64c.36-1,.72-1.9,1.08-2.81a.5.5,0,0,1,.65-.28.49.49,0,0,1,.28.65c-.36.91-.72,1.84-1.07,2.79A.51.51,0,0,1,341.29,1113.13Zm28-.9h-.11l-2.93-.67a.49.49,0,0,1-.37-.6.5.5,0,0,1,.6-.38l2.92.67a.5.5,0,0,1,.38.6A.51.51,0,0,1,369.34,1112.23Zm-9.75-2.23-.11,0-2.93-.66a.5.5,0,0,1,.22-1l2.93.67a.5.5,0,0,1-.11,1Zm-9.76-2.22-.11,0-2.93-.66a.5.5,0,0,1-.38-.6.49.49,0,0,1,.6-.37l2.93.66a.5.5,0,0,1-.11,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M459.47,1255.32l-33-7.89a8.75,8.75,0,0,1-6.68-9.51l3.79-32.64a8.75,8.75,0,0,1,10.74-7.48l39.62,9.49a8.73,8.73,0,0,1,6.28,11.27l-10.42,31.06A8.75,8.75,0,0,1,459.47,1255.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M456.81,1248.52l-25.1-6a6.68,6.68,0,0,1-5.09-7.24l2.89-24.84a6.65,6.65,0,0,1,8.18-5.69l30.15,7.21a6.67,6.67,0,0,1,4.78,8.59l-7.93,23.63A6.67,6.67,0,0,1,456.81,1248.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M872.6,718.22l-10.86-5-.07,0a1.08,1.08,0,0,1-.54-1.44,1.1,1.1,0,0,1,1.45-.55h0l10.91,5.17a1,1,0,0,1,.47,1.33,1,1,0,0,1-1.31.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M850.58,709.05l-11.4-3.5-.07,0a1.28,1.28,0,0,1,.75-2.45h0l11.49,3.72a1.19,1.19,0,0,1-.72,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M827.6,702.77l-11.74-2.07h-.08a1.47,1.47,0,0,1,.5-2.89h0l11.86,2.28a1.37,1.37,0,0,1-.49,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M804,699.34l-11.89-.7h-.09a1.62,1.62,0,1,1,.19-3.24h0l12.06.84a1.56,1.56,0,0,1-.2,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M780.24,698.62l-11.89.65h-.1a1.76,1.76,0,1,1-.19-3.52h0l12.09-.52a1.69,1.69,0,0,1,.16,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M756.52,700.57l-11.74,1.95-.1,0a1.91,1.91,0,1,1-.62-3.76h0l12-1.85a1.84,1.84,0,0,1,.58,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M733.17,705.1l-11.45,3.21-.11,0a2,2,0,0,1-1.1-3.93h0l11.7-3.13a2,2,0,0,1,1,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M710.46,712.13l-11,4.43-.12,0a2.18,2.18,0,1,1-1.62-4h0l11.3-4.39a2.11,2.11,0,0,1,1.55,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M688.67,721.59l-10.46,5.61-.11.07a2.32,2.32,0,0,1-2.2-4.09h0l10.75-5.62a2.25,2.25,0,0,1,2.11,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M668.09,733.4l-9.74,6.77-.11.08a2.46,2.46,0,0,1-2.81-4h0l10-6.82a2.39,2.39,0,0,1,2.71,3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M649,747.49c-.75.64-1.52,1.26-2.25,1.93l-2.21,2-4.41,4-.09.08a2.6,2.6,0,1,1-3.47-3.87l0,0,4.57-4,2.28-2c.75-.67,1.55-1.3,2.33-1.95a2.53,2.53,0,0,1,3.28,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M631.76,763.7l-7.94,8.81-.1.11a2.73,2.73,0,1,1-4.06-3.66l0,0,8.24-8.93a2.67,2.67,0,0,1,3.94,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M616.38,781.73l-7,9.59-.09.12a2.85,2.85,0,1,1-4.61-3.34l0,0L612,778.3a2.79,2.79,0,0,1,4.51,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M603,801.27l-5.93,10.26-.07.13a3,3,0,0,1-5.11-2.95v0L598,798.22a2.9,2.9,0,0,1,5,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M591.65,822.08l-4.87,10.8-.07.14a3,3,0,0,1-5.55-2.51v0l5.08-11a3,3,0,0,1,5.46,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M582.44,843.91l-3.8,11.22,0,.15a3.15,3.15,0,0,1-6-2v0l4-11.47a3.09,3.09,0,0,1,5.85,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M575.38,866.53l-2.72,11.53,0,.15a3.25,3.25,0,1,1-6.32-1.49v0l2.88-11.8a3.2,3.2,0,0,1,6.22,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M570.5,889.71l-1.6,11.73,0,.16a3.35,3.35,0,0,1-6.64-.91v0l1.75-12a3.3,3.3,0,0,1,6.53.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M567.86,913.23l-.48,11.83v.17a3.44,3.44,0,0,1-6.88-.28v0l.59-12.15a3.39,3.39,0,0,1,6.78.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M567.47,936.89l.66,11.82v.17a3.52,3.52,0,0,1-7,.4v0l-.61-12.17a3.48,3.48,0,0,1,7-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M569.39,960.46c.29,1.95.53,3.91.86,5.85l1,5.83,0,.1a3.59,3.59,0,1,1-7.08,1.19v0l-1-6c-.33-2-.56-4-.85-6a3.55,3.55,0,0,1,7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M573.63,983.72l3,11.46,0,.16a3.66,3.66,0,0,1-7.09,1.83v0l-3-11.81a3.62,3.62,0,0,1,7-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M580.06,1006.48l4,11.14.06.16a3.73,3.73,0,0,1-7,2.52v0l-4-11.48a3.7,3.7,0,0,1,7-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M588.55,1028.57l5,10.74.07.15a3.81,3.81,0,1,1-6.91,3.19v0l-5-11.07a3.77,3.77,0,0,1,6.85-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M599,1049.82l5.88,10.28.08.14a3.88,3.88,0,0,1-6.73,3.85v0l-6-10.6a3.84,3.84,0,0,1,6.68-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M611.14,1070.11l6.72,9.75.09.13a3.95,3.95,0,0,1-6.5,4.48v0l-6.85-10a3.91,3.91,0,0,1,6.46-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M625,1089.32l7.49,9.16.11.12a4,4,0,1,1-6.22,5.09v0l-7.65-9.45a4,4,0,0,1,6.18-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M640.32,1107.34l8.21,8.53.11.12a4.06,4.06,0,1,1-5.85,5.63h0l-8.41-8.81a4,4,0,0,1,5.84-5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M657.07,1124.06l8.86,7.84.13.11a4.11,4.11,0,1,1-5.44,6.15h0l-9.08-8.09A4.08,4.08,0,1,1,657,1124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M675.11,1139.37l9.47,7.09.14.1a4.15,4.15,0,0,1-5,6.64h0l-9.72-7.33a4.12,4.12,0,1,1,5-6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M694.34,1153.15l5,3.18c1.65,1.07,3.35,2.06,5,3.1l.09,0a4.19,4.19,0,0,1-4.39,7.14h0c-1.72-1.07-3.47-2.09-5.17-3.21l-5.12-3.29a4.17,4.17,0,1,1,4.51-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M714.63,1165.3l10.5,5.47.15.07a4.24,4.24,0,0,1-3.91,7.52h0l-10.77-5.66a4.21,4.21,0,1,1,3.92-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M735.83,1175.82l10.89,4.65.15.06a4.28,4.28,0,1,1-3.36,7.87h0l-11.17-4.82a4.25,4.25,0,1,1,3.37-7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M757.78,1184.7l11.21,3.83.15,0a4.32,4.32,0,0,1-2.79,8.18h0l-11.49-4a4.29,4.29,0,0,1,2.8-8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M780.33,1191.94l11.46,3,.15,0a4.36,4.36,0,0,1-2.22,8.44h0L778,1200.3a4.35,4.35,0,0,1,2.23-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M803.34,1197.55l11.65,2.19.15,0a4.41,4.41,0,1,1-1.64,8.66h0l-11.94-2.3a4.38,4.38,0,1,1,1.66-8.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M826.7,1201.55l11.76,1.4.15,0a4.43,4.43,0,1,1-1.05,8.79h0l-12.06-1.46a4.42,4.42,0,0,1,1.06-8.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M850.27,1204l11.84.62h.15a4.44,4.44,0,0,1-.46,8.87h0l-12.13-.65a4.43,4.43,0,1,1,.47-8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M874,1204.8l11.85-.17H886a4.46,4.46,0,1,1,.13,8.91h0l-12.14.16a4.45,4.45,0,1,1-.12-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M897.65,1204.07l11.82-1,.14,0a4.47,4.47,0,1,1,.72,8.91h0l-12.1,1a4.46,4.46,0,1,1-.71-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M921.24,1201.77l5.87-.85c1.95-.29,3.91-.54,5.86-.88a4.49,4.49,0,1,1,1.51,8.85h-.06c-2,.33-4,.59-6,.89l-6,.86a4.48,4.48,0,0,1-1.28-8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M944.64,1197.94l11.61-2.46.13,0a4.5,4.5,0,0,1,1.87,8.8h0l-11.87,2.51a4.49,4.49,0,0,1-1.86-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M967.78,1192.67l11.44-3.15.13,0a4.51,4.51,0,0,1,2.39,8.7h0l-11.7,3.2a4.5,4.5,0,1,1-2.37-8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M990.58,1186.05l11.25-3.78.12,0a4.53,4.53,0,0,1,2.88,8.59h0l-11.5,3.84a4.52,4.52,0,0,1-2.87-8.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1013,1178.19l11-4.37.11,0a4.54,4.54,0,0,1,3.34,8.45h0l-11.27,4.44a4.53,4.53,0,1,1-3.32-8.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1035,1169.18l10.84-4.9.09,0a4.56,4.56,0,1,1,3.76,8.3h0l-11,5a4.55,4.55,0,1,1-3.74-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1056.55,1159.13l10.62-5.37.09,0a4.56,4.56,0,0,1,4.12,8.14l-10.79,5.47a4.56,4.56,0,1,1-4.13-8.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1077.68,1148.16l10.4-5.8.08,0a4.54,4.54,0,1,1,4.43,7.93l-10.54,5.91a4.56,4.56,0,1,1-4.45-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1098.37,1136.36l10.19-6.2.07,0a4.53,4.53,0,0,1,4.71,7.74l-10.32,6.29a4.54,4.54,0,0,1-4.72-7.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M1118.64,1123.8l10-6.54.06,0a4.51,4.51,0,1,1,4.95,7.54l-10.08,6.63a4.52,4.52,0,0,1-5-7.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1138.49,1110.57l9.78-6.85,0,0a4.49,4.49,0,0,1,5.16,7.36l-9.88,6.93a4.5,4.5,0,1,1-5.17-7.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1158,1096.74l9.59-7.11,0,0a4.47,4.47,0,1,1,5.33,7.18l-9.67,7.2a4.48,4.48,0,1,1-5.35-7.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1177.05,1082.39l9.42-7.35,0,0a4.45,4.45,0,0,1,5.48,7l-9.49,7.43a4.46,4.46,0,0,1-5.5-7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1195.81,1067.58l9.26-7.55,0,0a4.43,4.43,0,1,1,5.61,6.87l-9.32,7.63a4.44,4.44,0,1,1-5.63-6.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1214.26,1052.38l9.13-7.74,0,0a4.42,4.42,0,0,1,5.73,6.74l-9.17,7.79a4.43,4.43,0,1,1-5.74-6.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M1232.46,1036.83l9-7.86h0a4.37,4.37,0,1,1,5.76,6.58l-9,7.94a4.4,4.4,0,1,1-5.81-6.61v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1250.48,1021.06l9-8h0a4.32,4.32,0,0,1,5.76,6.44l-8.94,8a4.35,4.35,0,0,1-5.81-6.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1268.35,1005.09l8.89-8h0a4.27,4.27,0,0,1,5.74,6.32l-8.88,8.09a4.3,4.3,0,0,1-5.79-6.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1286.12,989l8.87-8.07a4.21,4.21,0,0,1,5.69,6.21l-8.84,8.13a4.24,4.24,0,0,1-5.74-6.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M1303.85,972.83l8.87-8.09a4.16,4.16,0,0,1,5.62,6.14l-8.83,8.12a4.19,4.19,0,0,1-5.67-6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1321.6,956.66l8.89-8.07a4.11,4.11,0,1,1,5.52,6.08h0l-8.85,8.09h0a4.13,4.13,0,1,1-5.58-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1339.41,940.54l8.95-8a4.05,4.05,0,0,1,5.41,6h0l-8.89,8h0a4.08,4.08,0,0,1-5.47-6.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1357.34,924.54l9-7.93a4,4,0,0,1,5.28,6h0l-9,8h0a4,4,0,1,1-5.34-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1375.47,908.73l9.14-7.81a3.9,3.9,0,0,1,5.09,5.91l0,0-9,7.85h0a3.94,3.94,0,0,1-5.17-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1393.82,893.18l9.28-7.67a3.81,3.81,0,0,1,4.88,5.85l0,0-9.17,7.69,0,0a3.86,3.86,0,1,1-5-5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1412.45,877.93l9.43-7.49a3.72,3.72,0,0,1,4.65,5.82l0,0-9.31,7.51,0,0a3.76,3.76,0,1,1-4.72-5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1431.39,863.06l9.61-7.27a3.63,3.63,0,0,1,4.4,5.78l0,0-9.48,7.28,0,0a3.68,3.68,0,1,1-4.48-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M1450.7,848.65l9.8-7a3.54,3.54,0,0,1,4.14,5.74l0,0-9.66,7,0,0a3.59,3.59,0,1,1-4.22-5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1470.4,834.77c3.33-2.25,6.65-4.51,10-6.72a3.45,3.45,0,0,1,3.82,5.75c-3.31,2.21-6.58,4.48-9.87,6.73l0,0a3.5,3.5,0,1,1-4-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1490.57,821.53l10.31-6.3a3.34,3.34,0,0,1,3.51,5.68l-.07,0-10.11,6.32-.07,0a3.4,3.4,0,0,1-3.6-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1511.35,809.2l10.64-5.75a3.21,3.21,0,0,1,3.09,5.63l-.09,0-10.42,5.76-.08.05a3.27,3.27,0,1,1-3.17-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1532.82,798l11-5a3.08,3.08,0,0,1,2.61,5.59l-.1,0-10.76,5.07-.1,0a3.15,3.15,0,0,1-2.68-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1555,788.34l11.39-4.18a3,3,0,0,1,2.07,5.56l-.12,0-11.11,4.2-.12,0a3,3,0,0,1-2.14-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1578,780.51l11.75-3.09a2.84,2.84,0,0,1,1.47,5.49l-.15,0-11.43,3.12-.14,0a2.9,2.9,0,0,1-1.53-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1601.65,775l12-1.73a2.69,2.69,0,0,1,.8,5.31l-.16,0-11.69,1.86-.16,0a2.77,2.77,0,1,1-.87-5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1625.82,772.26l12.17-.18a2.52,2.52,0,0,1,.11,5h-.17l-11.82.35h-.18a2.6,2.6,0,0,1-.15-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1650.15,772.73q6.09.57,12.1,1.68a2.35,2.35,0,0,1-.82,4.62q-5.82-1-11.69-1.45a2.43,2.43,0,0,1,.37-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1674.13,777.14q5.88,1.62,11.6,3.72a2.17,2.17,0,0,1-1.47,4.09c-3.72-1.3-7.49-2.46-11.3-3.45a2.26,2.26,0,0,1,1.14-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1697,785.52q5.52,2.57,10.82,5.56a2,2,0,0,1-2,3.49c-3.46-1.89-7-3.65-10.6-5.25a2.09,2.09,0,1,1,1.7-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1718.13,797.5q5,3.42,9.75,7.26a1.83,1.83,0,0,1-2.29,2.85q-4.65-3.68-9.6-6.93a1.92,1.92,0,0,1,2.11-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1737,812.85q4.35,4.24,8.29,8.88a1.66,1.66,0,0,1-2.51,2.16q-3.88-4.46-8.2-8.53a1.74,1.74,0,0,1,2.4-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1752.64,831.4a109.76,109.76,0,0,1,6.3,10.4,1.46,1.46,0,0,1-2.56,1.39,109.27,109.27,0,0,0-6.32-10,1.57,1.57,0,1,1,2.56-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1764,852.85a97.52,97.52,0,0,1,3.68,11.59,1.23,1.23,0,0,1-2.38.61,92.25,92.25,0,0,0-3.8-11.2,1.35,1.35,0,0,1,2.49-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1769.86,876.39a91,91,0,0,1,.58,11.78,1,1,0,0,1-2,0,88.4,88.4,0,0,0-.79-11.5,1.12,1.12,0,0,1,2.21-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1566.45,1293.73s2.07,11.1,3.14,22.09a7.6,7.6,0,0,1-7.18,8.29c-14.64.75-46,2.23-57.23,1.84a2.47,2.47,0,0,1-2.2-3.36h0a5.5,5.5,0,0,1,2.79-3l51.55-24.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M1568,1287.19l-1.46,13.31s-9,4.31-15.26-.39l3.61-14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1564.43,1037.24c.71,3.46,5.31,173.23-12.12,249.49a2.59,2.59,0,0,0,1.55,3,45,45,0,0,0,14.81,2.86,4.45,4.45,0,0,0,4.38-3.23c5-17.71,29-106.4,31.47-190.92,2.72-94.45,0-3.22,0-3.22l-2.68-58.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1626.06,1299s3.18,5.59,6.35,20.47a4.63,4.63,0,0,1-4,5.58c-4.83.52-12.28,1.2-18.24,1.22a4.62,4.62,0,0,1-4.62-5.1c.61-5.45,2.59-14.4,8.88-21.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1628.64,1281.84l-3.49,20.14s-3.62,2.74-10.85.85l1.55-21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1636.31,1041.76c15.7,89.44-1.11,221.45-7,247.31a4,4,0,0,1-3.22,3.08,27,27,0,0,1-11.62-.35,3.7,3.7,0,0,1-2.68-3.37c-1-20.85-.77-148.93-15.08-199.41a11.48,11.48,0,0,0-4.5-6.3l-27-18.83-2.36-30.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1540.11,872.92c44.47-1.16,93.68,10.79,93.68,10.79,14,77.24,3.9,166.59,3.9,166.59-34.35,9.36-73.34-4.83-73.34-4.83-6-32.28-33.6-123-33.6-123-21.76-2.49-39.73-8.59-54.55-16.74,11.12-13.14,16.26-29.78,18.47-39.61C1510.45,870.82,1526.39,873.28,1540.11,872.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M1408.08,808.65a8.52,8.52,0,0,1,9.88-2.88c6.81,27.59,41.34,49.69,76.71,60.31-2.21,9.83-7.35,26.47-18.47,39.61C1417.36,873.34,1408.08,808.65,1408.08,808.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1409.16,810c-.45,1.46,4.87,3.62,7.93-2.35.08-2.85,1.7-15.08,0-17.38-9.18-12.28-26.91-27.61-26.91-27.61a4.18,4.18,0,0,0-.47,5.82l8.61,8.8c-1.75,3.24-3.9,6-4.88,9.9a11.94,11.94,0,0,0,1.27,8.78c1.53,2.68,3.6,6.17,5.56,8.89A11.8,11.8,0,0,0,1409.16,810Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M1402.08,783l7.83,6.52,2.51,6.53-6.86,7.76s-2.45-13-4.21-15.8S1400.47,783.83,1402.08,783Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1617.13,926.94l16.66-43.23s41.82,27.83,49,63.56c-7.85.66-22.11,2.83-36,10C1643.52,940.43,1617.13,926.94,1617.13,926.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M1581.21,967.82s46.9,25.92,62.43,3.26a17.7,17.7,0,0,0,3.11-13.78c13.92-7.2,28.18-9.37,36-10a49.43,49.43,0,0,1-5,33.92c-27.09,50.7-102.58-1.81-102.58-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1584.82,836.37l14.55,40.8a1.49,1.49,0,0,1-.66,1.79c-3.84,2.17-17.68,8.46-34.53-2a7,7,0,0,1-3.25-4.93L1556,836.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1553.66,798.76S1538.4,828.17,1540.5,840s21.36,10.77,38.09,1L1590,809.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1577.7,825.47a1.2,1.2,0,0,1-.54-1.76c1.22-1.91,3.52-5.82,4.23-9.22,0,0,2.78-1.82-7.15-4.1s-24.73-5.81-27.92-14.21c-3.1-8.19,4.65-28.94,17.5-12.59a1.21,1.21,0,0,0,1.91,0c2-2.73,7.47-8.4,15.1-5.06,7.13,3.12,8,8.32,7.91,10.94a1.2,1.2,0,0,0,1.43,1.22c3.59-.72,12.2-1.39,16.31,7.41,3.39,7.25,1.27,11.4-.67,13.43a1.21,1.21,0,0,0,.53,2c2.37.7,5.44,2.67,5.19,8.2-.35,7.66-8.91,7.06-11.35,6.74a1.18,1.18,0,0,0-1.07.39c-2.06,2.33-11.37,12.22-21.54,13.5a1.21,1.21,0,0,1-1.29-1.59l4.28-12.85a1.21,1.21,0,0,0-.67-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1576,827.3s11-7.69,11.86-1.31-9.88,9.36-15.24,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1590.8,1008.78l-25.55-89.22a2.61,2.61,0,0,0-2.21-1.87c-4.62-.54-18-2.06-33.53-3.37-18.65-1.58-40.31-2.86-53.26-1.77a2.61,2.61,0,0,0-2.13,3.76c7.36,14.89,37.64,75.47,52.8,95.32a2.65,2.65,0,0,0,2.11,1l59.28-.56A2.62,2.62,0,0,0,1590.8,1008.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1584.62,987.23s3.56-14.64,2.13-19.83-4.22-11.87-13.49-10.38a134.87,134.87,0,0,0-20.21,5.39s.55,6.76,7.6,4.58l-4.37,3.38s.62,5.41,6.57,2.52l-4.06,4.48s2.56,4.45,6.93,1.6S1572.2,989,1584.62,987.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1531.22,941a7.5,7.5,0,1,1-7.5-7.5A7.5,7.5,0,0,1,1531.22,941Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1562.83,945.76l-5.2-17.65a6.55,6.55,0,0,0-4.92-4.59c-16.35-3.41-61-4.13-61.48-4.14l0-1c.45,0,45.22.73,61.66,4.16a7.56,7.56,0,0,1,5.68,5.29l5.2,17.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1252.82,1195.6c-2.72,4-13.55,95.28-15.24,129a4,4,0,0,0,4,4.18h0a4,4,0,0,0,3.94-3.38l19.8-126.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1339.85,1195.6c2.72,4,13.55,95.28,15.24,129a4,4,0,0,1-4,4.18h0a4,4,0,0,1-3.94-3.38l-19.8-126.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1236.45,1188.48v1c-.07,7.15,6.1,13,13.82,13.16l91.52,1.55c7.61.13,14-5.37,14.32-12.41l.05-.91c.38-7.35-5.86-13.55-13.8-13.69l-91.55-1.64C1243,1175.4,1236.51,1181.22,1236.45,1188.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1429.23,1321.27c-16.27,0-23.47-1.4-26.69-2.67a6.18,6.18,0,0,0,6,4.78h57.55a2.8,2.8,0,0,0,2.7-3.54C1462.24,1320.37,1448.31,1321.27,1429.23,1321.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1468.8,1319.84a2.68,2.68,0,0,0-.47-1c-4.38-5.59-13.19-14.38-25.17-14.21-17.55.24-23.67,2.15-37.3.1l-3.22,10.67a6.15,6.15,0,0,0-.1,3.18c3.22,1.27,10.42,2.67,26.69,2.67C1448.31,1321.27,1462.24,1320.37,1468.8,1319.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1409.81,1293.26l-4,13.43s8.74,4,16.44.79l1.51-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1529.09,1312.81c-12.68,10.19-19.17,13.61-22.47,14.64a6.16,6.16,0,0,0,7.67-.06l44.86-36a2.8,2.8,0,0,0-.1-4.44C1554.27,1291.43,1544,1300.85,1529.09,1312.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1559.05,1286.91a2.77,2.77,0,0,0-1-.46c-6.9-1.6-19.25-2.9-28.48,4.73-13.53,11.19-17.11,16.5-29,23.45l4.14,10.29a6,6,0,0,0,1.9,2.53c3.3-1,9.79-4.45,22.47-14.64C1544,1300.85,1554.27,1291.43,1559.05,1286.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1325.33,1140.24s97.39,8,117.37,17.35-16.3,141.24-16.3,141.24-5.44,2.61-17.54-1.15c0,0,12.41-97.28,3.17-118.38l-105.46-17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1490.9,1296.12c.9.82,9.68,18.51,9.68,18.51s9.76-2.11,11.75-8.29l-8.78-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1266.66,1139.42a49.4,49.4,0,0,0-3,17.79,26.7,26.7,0,0,0,25.48,26.12l115.14,5.25a5.53,5.53,0,0,1,5.1,4.15c2.71,10.47,15.93,42.61,80.58,106.74a5.22,5.22,0,0,0,6.44.7l9.21-5.81a2.13,2.13,0,0,0,.69-2.87l-67-114.48a25.93,25.93,0,0,0-15.76-11.69l-98.13-25.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1380.13,960.59S1367.8,982.4,1355.22,993l26,14.5s5.85-23.09,19.23-29.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M1264.57,1140.24s31.09,7.57,60.76,0c0,0,41.51-55.81,57.57-71,0,0,25.62,40.42,82.65,46.15l3.18-7.1s-45.4-20.93-59.38-53.09-19.59-45.87-32.3-54.25c-7.92-5.23-12.66-8.8-15.11-10.75a4.05,4.05,0,0,0-4.66-.29C1343.79,998.13,1280.3,1041.61,1264.57,1140.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1381.22,1068.7a2.22,2.22,0,0,1-1.78-.88,124.47,124.47,0,0,1-15.68-27.79,2.24,2.24,0,0,1,4.19-1.61,121.88,121.88,0,0,0,15,26.67,2.24,2.24,0,0,1-1.78,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1462.12,1104.57l6.42-1.71,19.49-4.51a9,9,0,0,1,6.84,1.16l16.76,10.54-46.27-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M1399.72,927.89s12,19.93,14.06,30.94,5.42,17.9-7.11,21.82-24.18-1-31.5-11.32c0,0-11.41-15.82-10.27-23.07S1399.72,927.89,1399.72,927.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1378.51,960.81l1.62-.22s-8.48-12.82-2.93-16,28.19-11,32.12-19.91c3.79-8.59-1.88-18.3-8.72-20.32a.85.85,0,0,0-1,.55l-.4,1.08a.88.88,0,0,1-1.63,0h0a.88.88,0,0,0-1.6,0c-1.21,2.67-4.84,7.23-15.72,10.76-15.44,5-25.07,12.79-23.88,23.77a.89.89,0,0,1-1.26.89c-1.26-.56-3.17-.65-5.39,1.78-3.87,4.23-.84,13.48,9.71,20a.88.88,0,0,1,.15,1.4c-1.58,1.35-3.8,4.37,3.34,7.06,7.3,2.75,11.29,1.82,12.76,1.23a.88.88,0,0,0,.54-1l-1.87-9.62a.87.87,0,0,1,.74-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1379.18,962.78s-5.29-13-10.85-8.45,5.14,14.71,10.07,14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1444.24,1119.13h.23l98.86-.1a4.42,4.42,0,1,0,0-8.83l-98.85.1a4.42,4.42,0,0,0-.22,8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1581.61,1022.31a2,2,0,0,0-.1.21l-41.6,89.68a4.42,4.42,0,1,0,8,3.71l41.59-89.68a4.42,4.42,0,0,0-7.91-3.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1830.05,
    y: 1209.25,
    width: 10.43,
    height: 112.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1881,1324.27h-91.39a6.8,6.8,0,0,1,6.79-6.8h77.8a6.81,6.81,0,0,1,6.8,6.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1779.62,
    y: 1183.97,
    width: 114.9,
    height: 32.59,
    rx: 11.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1758.23,1134s-15.5,2.4-32.93,14.06a8.68,8.68,0,0,0-3.84,8.3c2.09,16.53,10.67,70,39,122.32a13.16,13.16,0,0,1,1.27,9l-4.92,22.88-9.12,8.55h23.49l15.63-42.32-6.68-2.11a12.66,12.66,0,0,1-8.84-11.85l-.78-45.39c.67-20.23-12.4-34.18-12.4-34.18l37.5-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1738.49,1323.29c-2.14,2.79,23,6.49,35.73.37,0,0,17.62-30.66,17.62-46.45,0,0-1.4-3.21-11.74-2.48,0,0-5.92,36.29-12.17,40.36s-17.47.41-17.47.41S1741.65,1319.16,1738.49,1323.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1790.84,1184c-.2-.34-40.38-4.83-40.38-4.83s1.31,12.22-2.8,29-63.11,89.68-63.11,89.68l6.19,19.61c-19.13,6.67-37.94,7.73-56.45,3.4l38.33-23s35.88-122.27,57.86-144.08l40.28-13.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1881,1112.83s23.15,34.43,25,50.14-6.35,22.09-30.64,23.14-89.14,1-89.14,1l-55.35-47.3s40.34-14.4,50.83-18.47S1881,1112.83,1881,1112.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1688.4,1310.87s6.66,6.45,2.16,13.63c0,0-52.76,9.35-67.08,5.11,0,0,3-6.79,19.1-14.52l-1.19.91a1.93,1.93,0,0,0,1.28,3.46C1653.3,1318.86,1675.29,1316.91,1688.4,1310.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1780.67,894.45c47.33-8.05,69.61,30.55,68,38.66a1.48,1.48,0,0,0,1.86,1.7c5.43-1.46,17.43-3.31,24.87,6,6.57,8.23,1.66,16-2.34,20.26a1.49,1.49,0,0,0,1.25,2.52c10-1.26,31.69-1.56,35.24,18.78,3.31,19-9.88,24.3-17.71,25.81a1.49,1.49,0,0,0-.5,2.72c3.91,2.48,8.43,7.6,6.61,17.7-2.87,15.83-33.91,14.54-37.54,14.33a1.48,1.48,0,0,1-.65-.19L1810,1014.4a1.48,1.48,0,0,1-.73-1l-10-58a1.49,1.49,0,0,1,.39-1.29l-32.41-45.75C1755.46,906.61,1780.11,894.54,1780.67,894.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M1818.34,1108.27s-26.95-25.67-40.23-42.68a36.06,36.06,0,0,1-6.1-32.46c6-20.42,16.82-41.56,17.8-44.85,1.51-5,31.74-4.83,31.74-4.83s59.48,38.6,82.85,104l-26.24,8.17s-15.54-26.06-30.88-42.62c0,0,26.55,35.08,27.49,49.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M1786.16,960.09c.31,1,8.2,27.21,8.82,27.75s17.3,1.44,25.16-3.93l-19.48-38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1754.53,926.49s-3.81,15,6.73,35.13,22.5,20.13,29,13.68,14.58-17.39,12.67-36.88S1760,907.42,1754.53,926.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1788.36,939.48s-17.5-26.76-33.92-5.7l-.3,7.66s-19.22-2.28-15.85-19.91,20-28.64,41.37-21,33.65,15.47,35,30.8-10.81,12-10.81,12-4-10.79-9.64-11.92-4.19,7.3-4.19,7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1792.84,946.12s-9.08-13.7.22-15.74,7.86,13.35,6.86,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1763.42,1110.17l19.81-19.09,27.4,11.58s27.28,4.22,42.89,0l15.61-4.23,35.27-11,5.54,15.66a9.42,9.42,0,0,1-3.44,10.83,62.27,62.27,0,0,1-8.91,5.55c-4.64,2-114.52-1.41-114.52-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1838.38,1119.18h-.26l-114.91-.12a5.15,5.15,0,0,1,0-10.29l114.9.13a5.14,5.14,0,0,1,.25,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1619.92,1014.85h95.69a18.25,18.25,0,0,1,16.5,10.46l44.24,93.8H1657.43a11.08,11.08,0,0,1-10.31-7l-34.3-86.8A7.64,7.64,0,0,1,1619.92,1014.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1687.34,1063c2.07,6.44.54,12.7-3.42,14s-8.86-2.91-10.93-9.35-.55-12.7,3.42-14S1685.26,1056.51,1687.34,1063Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1394,1333.28a3.39,3.39,0,0,1-1.47-.34,4.2,4.2,0,0,1-2-5.33l78.08-198.11a3.62,3.62,0,0,1,4.89-2.13,4.22,4.22,0,0,1,2,5.34l-78.08,198.11A3.74,3.74,0,0,1,1394,1333.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1482,1333.28a3.72,3.72,0,0,1-3.42-2.46l-78.08-198.11a4.22,4.22,0,0,1,2-5.34,3.61,3.61,0,0,1,4.89,2.13l78.08,198.11a4.2,4.2,0,0,1-2,5.33A3.39,3.39,0,0,1,1482,1333.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1923.92,1333.28a3.39,3.39,0,0,1-1.47-.34,4.2,4.2,0,0,1-2-5.33l78.08-198.11a3.62,3.62,0,0,1,4.89-2.13,4.22,4.22,0,0,1,2,5.34l-78.08,198.11A3.74,3.74,0,0,1,1923.92,1333.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2011.88,1333.28a3.71,3.71,0,0,1-3.42-2.46l-78.08-198.11a4.22,4.22,0,0,1,1.95-5.34,3.62,3.62,0,0,1,4.89,2.13l78.07,198.11a4.19,4.19,0,0,1-1.94,5.33A3.39,3.39,0,0,1,2011.88,1333.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2042.07,1123.37a3.44,3.44,0,0,0-1.41-3.67,8.43,8.43,0,0,0-5.17-1.62H1357.9a9.14,9.14,0,0,0-6.49,2.36,3.68,3.68,0,0,0-.51,4.9l7.34,10.55c1.69,2.41,5.33,4,9.34,4h663.26c3.73,0,6.93-1.76,7.64-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M491.41,524.38a2,2,0,0,1-2-1.83l-.51-5.94a2,2,0,1,1,4-.35l.52,5.94a2,2,0,0,1-1.82,2.17Zm-1.55-17.9a2,2,0,0,1-2-1.83l-1-11.95a2,2,0,1,1,4-.35l1,12a2,2,0,0,1-1.82,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M624.67,476.56a2,2,0,0,1-1.06-.31,45.16,45.16,0,0,1-4.12-2.92A2,2,0,0,1,622,470.2a44.09,44.09,0,0,0,3.76,2.66,2,2,0,0,1-1.07,3.7Zm-12.22-11.43a2,2,0,0,1-1.61-.82,46,46,0,0,1-6-11,2,2,0,0,1,3.74-1.42,42.22,42.22,0,0,0,5.46,10,2,2,0,0,1-.43,2.79A1.92,1.92,0,0,1,612.45,465.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M701.74,351.21a2,2,0,0,1-.72-.13,94.61,94.61,0,0,0-11.2-3.55,2,2,0,0,1,1-3.88,98.85,98.85,0,0,1,11.67,3.7,2,2,0,0,1-.72,3.86Zm-23.22-5.79h-.25a93.81,93.81,0,0,0-11.1-.67h-.63a2,2,0,0,1,0-4h.64a97.66,97.66,0,0,1,11.58.7,2,2,0,0,1-.23,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M476.22,139.6a2,2,0,0,1-2-1.82l-1.09-12a2,2,0,0,1,4-.36l1.09,11.95a2,2,0,0,1-1.81,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M378.33,176.5a2,2,0,0,1-1.82-1.19l-4.88-11a2,2,0,0,1,3.66-1.62l4.87,11a2,2,0,0,1-1.83,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.58,279.17a2,2,0,0,1-1.34-.52l-.35-.31a2,2,0,1,1,2.66-3l.38.33a2,2,0,0,1-1.35,3.48Zm-10.4-6.79a2,2,0,0,1-.82-.18,37,37,0,0,0-10.93-3,2,2,0,1,1,.45-4A40.73,40.73,0,0,1,324,268.55a2,2,0,0,1-.81,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M639.65,214.13l11.46-3.7a1,1,0,1,1,.59,1.85l-.07,0h0l-11.65,2.77h0a.51.51,0,0,1-.61-.37A.5.5,0,0,1,639.65,214.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M662.73,207.27l11.77-2.68a1.72,1.72,0,0,1,.76,3.35l-.1,0-.07,0-11.78,2h0a1.36,1.36,0,0,1-.53-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M686.37,202.41l12-1.69a2.32,2.32,0,1,1,.65,4.59h-.2l-11.86,1.12h-.08a2,2,0,0,1-.47-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M710.36,199.51l12.08-.74a2.81,2.81,0,0,1,.34,5.6h-.21l-11.9.26h-.1a2.57,2.57,0,0,1-.21-5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M734.55,198.54l12.11.22a3.17,3.17,0,0,1-.11,6.33h-.21l-11.88-.57h-.11a3,3,0,0,1,.2-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M758.77,199.44l12.07,1.18a3.44,3.44,0,0,1-.67,6.85h0l-.14,0-11.8-1.38h-.12a3.33,3.33,0,0,1,.71-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M782.86,202.25l12,2.07a3.66,3.66,0,0,1-1.25,7.21h-.05l-.15,0-11.66-2.24-.13,0a3.55,3.55,0,0,1,1.28-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M806.68,206.9l11.76,3a3.74,3.74,0,0,1-1.86,7.25h0l-.13,0-11.47-3-.14,0a3.7,3.7,0,0,1,1.87-7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M830.08,213.38l11.5,3.89a3.82,3.82,0,0,1-2.45,7.23h0l-.14-.05-11.2-3.87-.14-.05a3.78,3.78,0,0,1,2.45-7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M852.91,221.65l11.14,4.81a3.78,3.78,0,1,1-3,6.94l-.12-.05L850,228.69l-.13-.06a3.79,3.79,0,0,1,3-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M875,231.7l10.74,5.66a3.73,3.73,0,0,1-3.48,6.6l-.11-.06-10.51-5.48-.13-.07a3.76,3.76,0,0,1,3.48-6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M896.27,243.44q2.6,1.58,5.15,3.23l5.11,3.27a3.69,3.69,0,1,1-4,6.21l-.08,0-5-3.17c-1.66-1.07-3.34-2.12-5-3.13a3.71,3.71,0,0,1,3.8-6.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M916.52,256.87l9.68,7.31a3.57,3.57,0,0,1-4.27,5.72l-.11-.08-9.54-7-.12-.09a3.64,3.64,0,0,1,4.32-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M935.59,271.87l9.08,8a3.43,3.43,0,0,1-4.51,5.17l-.1-.09-9-7.76-.1-.08a3.5,3.5,0,0,1,4.58-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M953.44,288.27l8.45,8.7a3.29,3.29,0,0,1-4.69,4.62l-.09-.09-8.38-8.42-.09-.09a3.37,3.37,0,0,1,4.77-4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M970,306l7.74,9.32a3.07,3.07,0,0,1-4.68,4l-.08-.09-7.76-9-.07-.09a3.18,3.18,0,1,1,4.81-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M985.09,324.94l7,9.86a2.84,2.84,0,0,1-4.59,3.34l-.06-.09-7.08-9.56-.07-.09a3,3,0,0,1,4.75-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M998.75,344.92l6.23,10.37a2.55,2.55,0,0,1-4.33,2.69l0-.08-6.4-10-.05-.09a2.7,2.7,0,0,1,4.56-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1010.83,365.89l5.44,10.79a2.23,2.23,0,0,1-4,2.07l0-.08-5.65-10.5,0-.07a2.4,2.4,0,0,1,4.22-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1021.29,387.67l4.57,11.18a1.85,1.85,0,0,1-3.4,1.46l0-.06-4.89-10.88,0-.07a2.06,2.06,0,1,1,3.75-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1030,410.18l3.7,11.48a1.43,1.43,0,0,1-2.71.93l0-.06-4.08-11.22,0-.06a1.65,1.65,0,1,1,3.11-1.13A.14.14,0,0,1,1030,410.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1036.93,433.27l2.76,11.72a.93.93,0,0,1-.7,1.12.92.92,0,0,1-1.11-.65v0l-3.23-11.51,0-.05a1.19,1.19,0,0,1,2.3-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1041.94,456.81l.94,5.87a.49.49,0,0,1-.41.57.51.51,0,0,1-.57-.39h0l-1.22-5.79v0a.63.63,0,0,1,.5-.76.65.65,0,0,1,.76.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1190.72,1011.4c-.28-3.48-3.84-6.5-9.86-8.91,6.54-3.61,10.17-7.48,9.86-11.28-.93-11.49-37.3-17.92-81.24-14.38s-78.82,15.73-77.89,27.21c.28,3.48,3.84,6.5,9.86,8.92-6.54,3.61-10.17,7.48-9.86,11.27.28,3.49,3.84,6.5,9.86,8.92-6.54,3.61-10.17,7.48-9.86,11.28.28,3.48,3.84,6.5,9.86,8.91-6.54,3.62-10.17,7.49-9.86,11.28.41,5.08,7.76,9.17,19.63,11.85a100.43,100.43,0,0,0,.3,12.41c1.72,21.16,25.52,37.76,57,37.76s58.74-22.63,59-43.86a108.32,108.32,0,0,0-.62-13.85c15.07-5,24.24-11.18,23.76-17.14-.28-3.48-3.84-6.5-9.86-8.92,6.54-3.61,10.17-7.48,9.86-11.27-.28-3.49-3.84-6.5-9.86-8.92C1187.4,1019.07,1191,1015.2,1190.72,1011.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1089.14,1081a189.72,189.72,0,0,1-34.85-2.85,1.05,1.05,0,0,1,.39-2.07c15.44,3,36.06,3.6,58.07,1.83,18-1.45,34.84-4.36,48.69-8.4a1.06,1.06,0,1,1,.59,2c-14,4.08-31,7-49.11,8.47C1104.74,1080.71,1096.76,1081,1089.14,1081Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1089.36,1060.83c-16.95,0-32.11-1.6-42.79-4.64a1.05,1.05,0,0,1,.57-2c15.23,4.34,39.76,5.68,65.61,3.6,25.56-2.06,49.41-7.25,63.78-13.88a1.06,1.06,0,0,1,.89,1.92c-14.59,6.72-38.7,12-64.5,14.06C1104.86,1060.51,1096.93,1060.83,1089.36,1060.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1089.15,1040.65c-18.31,0-34.33-1.87-45.12-5.43a1.05,1.05,0,1,1,.67-2c15,4.94,40.44,6.57,68,4.34,25.56-2.06,49.41-7.25,63.78-13.88a1.06,1.06,0,0,1,1.4.52,1,1,0,0,1-.51,1.4c-14.59,6.73-38.7,12-64.5,14.07C1104.74,1040.33,1096.75,1040.65,1089.15,1040.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1089.29,1020.45c-14.52,0-27.73-1.18-38-3.46a1.06,1.06,0,0,1,.46-2.06c15.44,3.43,37.67,4.32,61,2.44,25.34-2,49.06-7.18,63.46-13.73a1.05,1.05,0,1,1,.87,1.92c-14.61,6.65-38.59,11.85-64.16,13.91C1104.84,1020.13,1096.88,1020.45,1089.29,1020.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M1002.1,909.47a148.72,148.72,0,0,0-26.62-52c-26.16-33-68.83-100-74.09-191.53-7.64-133.1,110.42-199.75,218.14-190.7s214,89.26,202.38,213.09c-7.16,76.19-49.8,134-81.56,167.17a176.49,176.49,0,0,0-42.33,75c-9.53,34.41-32.2,77.28-86.1,79.9C1042.17,1013.82,1013.2,948.81,1002.1,909.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1129.73,983.89l37.69-245.15c.78-5.07,3.28-8.47,5.57-7.6s3.53,5.68,2.75,10.75l-.07.43L1132.73,985.2c-.32,1.82-1.25,3-2.07,2.57S1129.46,985.66,1129.73,983.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1090.61,985.84l-37.7-245.15c-.78-5.07-3.27-8.47-5.56-7.6s-3.53,5.68-2.75,10.74c0,.14.05.3.07.44l42.94,242.87c.32,1.83,1.25,3,2.07,2.58S1090.88,987.61,1090.61,985.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1167.15,717.69a3.94,3.94,0,0,0-4.94-1.28l-21,9.8-7.29-20.76a4.43,4.43,0,0,0-2.55-2.56,5.18,5.18,0,0,0-6.45,2l0,.07-17.26,31.47-16-44.8,0-.07a5.12,5.12,0,0,0-2.42-2.74,6.31,6.31,0,0,0-7.93,1.56l-24.13,33.22a2.91,2.91,0,0,0,.85,4.19,4,4,0,0,0,5.13-.55l21.25-23.7,19.13,42.62v0a3.44,3.44,0,0,0,1.69,1.65,4,4,0,0,0,5-1.3l18.46-29.62,6.95,15,.06.14c0,.11.11.21.17.32a4,4,0,0,0,5,1.28L1165.67,722A3,3,0,0,0,1167.15,717.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1241.18,820.66a1.51,1.51,0,0,1-1.21-2.4,281.1,281.1,0,0,0,17.69-26.87,1.5,1.5,0,0,1,2.6,1.5,284,284,0,0,1-17.88,27.16A1.49,1.49,0,0,1,1241.18,820.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1272.18,767.44a1.56,1.56,0,0,1-.59-.12,1.51,1.51,0,0,1-.78-2A233.65,233.65,0,0,0,1288.68,644c-3.78-30.94-12.68-50.64-12.77-50.84a1.5,1.5,0,1,1,2.73-1.25c.09.2,9.15,20.24,13,51.61a236.62,236.62,0,0,1-18.09,123A1.5,1.5,0,0,1,1272.18,767.44Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerimg1);
export default __webpack_public_path__ + "static/media/bannerimg_1.5998220402af679825521ebd03e8f909.svg";
export { ForwardRef as ReactComponent };